// mockPersonnelData.js — Mock personnel data for PersonnelMetrics page.
// Structure mirrors what a real SQL / D365 API response would return.
// Replace with live API calls when backend is ready.

const MOCK_PERSONNEL = [
  {
    employeeId: "101024",
    fullName: "Charles Parker",
    department: "QC",
    team: "QC",
    currentZone: "Station 8",
    currentJob: "Quality Check",
    lastUpdated: "2026-04-23 14:29",
    tagBatteryPct: 95,
    indirectMinutes: 60,
    avgTaskDurationMins: 77,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Quality Check",
        jobId: "JOB000027580",
        status: "Completed",
        duration: "60m",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000027584",
        status: "Completed",
        duration: "94m",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000042222",
        status: "Completed",
        duration: "301m",
      },
      {
        jobName: "Quality Check",
        jobId: "JOB000027580",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:54",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: [
        "Station 4",
        "Station 5",
        "Station 6",
        "Station 7",
        "Station 8",
      ],
      totalActiveTime: "7h 32m",
      totalIdleTime: "0h 28m",
    },
  },
  {
    employeeId: "100951",
    fullName: "Dominic Festa",
    department: "QC",
    team: "QC",
    currentZone: "Station 20",
    currentJob: "Quality Check",
    lastUpdated: "2026-04-23 14:29",
    tagBatteryPct: 92,
    indirectMinutes: 60,
    avgTaskDurationMins: 73,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Quality Check",
        jobId: "JOB000027580",
        status: "Completed",
        duration: "60m",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000027584",
        status: "Completed",
        duration: "94m",
      },
      {
        jobName: "QA Inspection",
        jobId: "JOB000042222",
        status: "Completed",
        duration: "301m",
      },
      {
        jobName: "Quality Check",
        jobId: "JOB000027580",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:50",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: [
        "Station 14",
        "Station 15",
        "Station 16",
        "Station 17",
        "Station 20",
      ],
      totalActiveTime: "7h 32m",
      totalIdleTime: "0h 28m",
    },
  },
  {
    employeeId: "C100308",
    fullName: "Hailey Spence",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "WELD",
    currentJob: "3D Finish Welding",
    lastUpdated: "2026-04-23 14:26",
    tagBatteryPct: 15,
    indirectMinutes: 10,
    avgTaskDurationMins: 42,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041530",
        status: "Completed",
        duration: "206m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041539",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["WELD"],
      totalActiveTime: "6h 10m",
      totalIdleTime: "0h 08m",
    },
  },
  {
    employeeId: "100971",
    fullName: "Adrian Hernandez",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 4",
    currentJob: "Exterior Wall Install",
    lastUpdated: "2026-04-23 14:28",
    tagBatteryPct: 42,
    indirectMinutes: 4,
    avgTaskDurationMins: 54,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043785",
        status: "Completed",
        duration: "107m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043788",
        status: "Completed",
        duration: "124m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043749",
        status: "Completed",
        duration: "118m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043761",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["Station 4", "Station 5"],
      totalActiveTime: "5h 52m",
      totalIdleTime: "0h 36m",
    },
  },
  {
    employeeId: "100950",
    fullName: "Jesus Felix",
    department: "Exteriors",
    team: "EXTERIORS",
    currentZone: "Station 16",
    currentJob: "Insulation",
    lastUpdated: "2026-04-23 14:18",
    tagBatteryPct: 74,
    indirectMinutes: 5,
    avgTaskDurationMins: 24,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000027526",
        status: "Completed",
        duration: "93m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "90m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "98m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000042381",
        status: "Completed",
        duration: "105m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000042346",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 16", "Station 17", "Station 20"],
      totalActiveTime: "6h 22m",
      totalIdleTime: "0h 06m",
    },
  },
  {
    employeeId: "101245",
    fullName: "Juan De Dios Felix",
    department: "Exterior Finishing",
    team: "EXTERIORS",
    currentZone: "Station 12",
    currentJob: "Sheathing (Exterior)",
    lastUpdated: "2026-04-23 14:22",
    tagBatteryPct: 67,
    indirectMinutes: 6,
    avgTaskDurationMins: 48,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043201",
        status: "Completed",
        duration: "18m",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000043215",
        status: "Completed",
        duration: "112m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043228",
        status: "Completed",
        duration: "95m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043234",
        status: "Completed",
        duration: "102m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043241",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 11", "Station 12", "Station 13"],
      totalActiveTime: "6h 15m",
      totalIdleTime: "0h 13m",
    },
  },
  {
    employeeId: "101089",
    fullName: "Juan Pablo Alarcon",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 6",
    currentJob: "Sub-FLooring Install",
    lastUpdated: "2026-04-23 14:19",
    tagBatteryPct: 81,
    indirectMinutes: 5,
    avgTaskDurationMins: 52,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043571",
        status: "Completed",
        duration: "22m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043584",
        status: "Completed",
        duration: "118m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043592",
        status: "Completed",
        duration: "125m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043608",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 4", "Station 5", "Station 6"],
      totalActiveTime: "6h 28m",
      totalIdleTime: "1h 00m",
    },
  },
  {
    employeeId: "101156",
    fullName: "Lorexy Quintero",
    department: "FFE - Flooring",
    team: "FFE/FLOOR",
    currentZone: "Station 19",
    currentJob: "Final Plumbing",
    lastUpdated: "2026-04-23 14:16",
    tagBatteryPct: 58,
    indirectMinutes: 8,
    avgTaskDurationMins: 25,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044134",
        status: "Completed",
        duration: "48m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044141",
        status: "Completed",
        duration: "149m",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000044157",
        status: "Completed",
        duration: "121m",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000044163",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 18", "Station 19", "Station 20"],
      totalActiveTime: "6h 45m",
      totalIdleTime: "0h 43m",
    },
  },
  {
    employeeId: "101178",
    fullName: "Maria Gutierrez",
    department: "Trim Electrical",
    team: "TRIM ELEC",
    currentZone: "Station 20",
    currentJob: "Final Electrical",
    lastUpdated: "2026-04-23 14:12",
    tagBatteryPct: 72,
    indirectMinutes: 4,
    avgTaskDurationMins: 38,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044215",
        status: "Completed",
        duration: "128m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044228",
        status: "Completed",
        duration: "52m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044234",
        status: "Completed",
        duration: "85m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044241",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 17", "Station 18", "Station 20"],
      totalActiveTime: "6h 18m",
      totalIdleTime: "1h 10m",
    },
  },
  {
    employeeId: "101064",
    fullName: "Samuel Watts",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "2DCELL",
    currentJob: "2D Material Handling",
    lastUpdated: "2026-04-23 14:09",
    tagBatteryPct: 64,
    indirectMinutes: 10,
    avgTaskDurationMins: 56,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043173",
        status: "Completed",
        duration: "119m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043153",
        status: "Completed",
        duration: "58m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043154",
        status: "Completed",
        duration: "93m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000044334",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["WELD", "SAW", "2DCELL"],
      totalActiveTime: "5h 52m",
      totalIdleTime: "0h 36m",
    },
  },
  {
    employeeId: "104914",
    fullName: "Rosselis Borges",
    department: "TNT",
    team: "TNT",
    currentZone: "Station 12",
    currentJob: "Tape and Mud",
    lastUpdated: "2026-04-23 14:07",
    tagBatteryPct: 79,
    indirectMinutes: 6,
    avgTaskDurationMins: 44,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044428",
        status: "Completed",
        duration: "214m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044434",
        status: "Completed",
        duration: "208m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044441",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 10", "Station 11", "Station 12"],
      totalActiveTime: "6h 35m",
      totalIdleTime: "0h 53m",
    },
  },
  {
    employeeId: "C100254",
    fullName: "Joe Hernandez",
    department: "HVAC",
    team: "HVAC",
    currentZone: "Station 8",
    currentJob: "Fire Protection / Sprinkler",
    lastUpdated: "2026-04-23 14:05",
    tagBatteryPct: 92,
    indirectMinutes: 10,
    avgTaskDurationMins: 67,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000046295",
        status: "Completed",
        duration: "98m",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000046698",
        status: "Completed",
        duration: "302m",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000046663",
        status: "In Progress",
        duration: "-",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 2,
      stationsVisited: ["Station 7", "Station 8"],
      totalActiveTime: "4h 15m",
      totalIdleTime: "1h 13m",
    },
  },
  {
    employeeId: "100985",
    fullName: "Robert Bauder",
    department: "Yard",
    team: "YARD",
    currentZone: "Station 24",
    currentJob: "Supervisor Tasks",
    lastUpdated: "2026-04-23 14:06",
    tagBatteryPct: 88,
    indirectMinutes: 435,
    avgTaskDurationMins: 193,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Supervisor Tasks",
        jobId: "JOB000027583",
        status: "Completed",
        duration: "184m",
      },
      {
        jobName: "Supervisor Tasks",
        jobId: "JOB000027583",
        status: "Completed",
        duration: "241m",
      },
      {
        jobName: "Supervisor Tasks",
        jobId: "JOB000027583",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 24"],
      totalActiveTime: "7h 16m",
      totalIdleTime: "0h 11m",
    },
  },
  {
    employeeId: "101203",
    fullName: "Zach Herbstreith",
    department: "Plumbing",
    team: "PLUMB",
    currentZone: "Station 11",
    currentJob: "Plumbing Rough-In",
    lastUpdated: "2026-04-23 14:08",
    tagBatteryPct: 71,
    indirectMinutes: 10,
    avgTaskDurationMins: 158,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044701",
        status: "Completed",
        duration: "156m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044715",
        status: "Completed",
        duration: "162m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044734",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 12", "Station 13", "Station 14"],
      totalActiveTime: "6h 42m",
      totalIdleTime: "0h 26m",
    },
  },
  {
    employeeId: "100962",
    fullName: "Samuel Godinez",
    department: "Interior Drywall",
    team: "INT. DRYWALL",
    currentZone: "Station 15",
    currentJob: "Gypsum and Install Boundary/Upper Ceiling",
    lastUpdated: "2026-04-23 14:10",
    tagBatteryPct: 83,
    indirectMinutes: 10,
    avgTaskDurationMins: 28,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000046405",
        status: "Completed",
        duration: "197m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000044857",
        status: "Completed",
        duration: "183m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000044863",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 14", "Station 15"],
      totalActiveTime: "5h 30m",
      totalIdleTime: "0h 26m",
    },
  },
  {
    employeeId: "101211",
    fullName: "Sheila Brown",
    department: "Inventory/Receiving",
    team: "INV/REC",
    currentZone: "GENERAL WAREHOUSE",
    currentJob: "Warehouse Work",
    lastUpdated: "2026-04-23 14:13",
    tagBatteryPct: 90,
    indirectMinutes: 447,
    avgTaskDurationMins: 447,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Warehouse Work",
        jobId: "JOB000044957",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 0,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["GENERAL WAREHOUSE", "Station 20", "Station 24"],
      totalActiveTime: "5h 52m",
      totalIdleTime: "0h 0m",
    },
  },
  {
    employeeId: "100988",
    fullName: "Alfredo Hernandez",
    department: "Roofing",
    team: "ROOF",
    currentZone: "Station 9",
    currentJob: "Sheathing (Exterior)",
    lastUpdated: "2026-04-23 14:15",
    tagBatteryPct: 76,
    indirectMinutes: 10,
    avgTaskDurationMins: 240,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000045015",
        status: "Completed",
        duration: "258m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000045028",
        status: "In Progress",
        duration: "-",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 8", "Station 9"],
      totalActiveTime: "5h 38m",
      totalIdleTime: "0h 12m",
    },
  },
  {
    employeeId: "104146",
    fullName: "Dylan Munoz",
    department: "Rough Electrical",
    team: "ROUGH ELEC",
    currentZone: "Station 6",
    currentJob: "Electrical Rough-In",
    lastUpdated: "2026-04-23 14:15",
    tagBatteryPct: 76,
    indirectMinutes: 10,
    avgTaskDurationMins: 255,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000046329",
        status: "Completed",
        duration: "261m",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000046695",
        status: "In Progress",
        duration: "-",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 6", "Station 7", "Station 8", "Station 9"],
      totalActiveTime: "5h 38m",
      totalIdleTime: "0h 12m",
    },
  },
  {
    employeeId: "100913",
    fullName: "Jesus Aguilar Parra",
    department: "Wall Build",
    team: "Wall Build",
    currentZone: "WALL BUILD",
    currentJob: "FRAME CAD, fabrication/assy",
    lastUpdated: "2026-04-23 13:33",
    tagBatteryPct: 76,
    indirectMinutes: 10,
    avgTaskDurationMins: 51,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000043909",
        status: "Completed",
        duration: "154m",
      },
      {
        jobName: "No Active Registration",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045034",
        status: "Completed",
        duration: "228m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045041",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WALL BUILD", "WELD", "Station 4"],
      totalActiveTime: "6h 23m",
      totalIdleTime: "0h 10m",
    },
  },
  {
    employeeId: "100934",
    fullName: "Clara Castillo",
    department: "Cabinet",
    team: "CAB",
    currentZone: "CAB",
    currentJob: "Cabinet Build Material Fabrication",
    lastUpdated: "2026-04-23 13:33",
    tagBatteryPct: 76,
    indirectMinutes: 10,
    avgTaskDurationMins: 31,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "36m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "36m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "36m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "29m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "29m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "38m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046926",
        status: "Completed",
        duration: "38m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046925",
        status: "In Progress",
        duration: "—",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000046925",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 11,
      jobsInProgress: 2,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 15", "Station 16", "CAB"],
      totalActiveTime: "5h 43m",
      totalIdleTime: "0h 23m",
    },
  },
  // ─────────────────────────────────────────────
  // TEAM: 2D/SAW  (15 employees)
  // Zone rule: 75% → 2DCELL, 25% → SAW
  // Base pattern: Samuel Watts (101064)
  // ─────────────────────────────────────────────
  {
    employeeId: "100917",
    fullName: "Ramon Armenta",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "2DCELL",
    currentJob: "2D Welding",
    lastUpdated: "2026-05-08 13:04",
    tagBatteryPct: 97,
    indirectMinutes: 10,
    avgTaskDurationMins: 58,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043201",
        status: "Completed",
        duration: "112m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043210",
        status: "Completed",
        duration: "55m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043218",
        status: "Completed",
        duration: "98m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043225",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WELD", "SAW", "2DCELL"],
      totalActiveTime: "5h 48m",
      totalIdleTime: "0h 32m",
    },
  },
  {
    employeeId: "100922",
    fullName: "Salvador Belmudes",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "2DCELL",
    currentJob: "2D Material Handling",
    lastUpdated: "2026-05-08 13:11",
    tagBatteryPct: 94,
    indirectMinutes: 10,
    avgTaskDurationMins: 54,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043231",
        status: "Completed",
        duration: "105m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043240",
        status: "Completed",
        duration: "62m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043248",
        status: "Completed",
        duration: "88m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043255",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WELD", "SAW", "2DCELL"],
      totalActiveTime: "5h 55m",
      totalIdleTime: "0h 28m",
    },
  },
  {
    employeeId: "100927",
    fullName: "Zachary Buckner",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "2DCELL",
    currentJob: "2D Welding",
    lastUpdated: "2026-05-08 13:18",
    tagBatteryPct: 91,
    indirectMinutes: 10,
    avgTaskDurationMins: 56,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043261",
        status: "Completed",
        duration: "57m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043269",
        status: "Completed",
        duration: "121m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043277",
        status: "Completed",
        duration: "53m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043284",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["SAW", "2DCELL"],
      totalActiveTime: "6h 02m",
      totalIdleTime: "0h 22m",
    },
  },
  {
    employeeId: "100929",
    fullName: "Timothy Caine",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "2DCELL",
    currentJob: "2D Material Handling",
    lastUpdated: "2026-05-08 13:25",
    tagBatteryPct: 98,
    indirectMinutes: 10,
    avgTaskDurationMins: 55,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043290",
        status: "Completed",
        duration: "116m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043298",
        status: "Completed",
        duration: "59m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043305",
        status: "Completed",
        duration: "94m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043312",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WELD", "2DCELL"],
      totalActiveTime: "5h 44m",
      totalIdleTime: "0h 38m",
    },
  },
  {
    employeeId: "105378",
    fullName: "James Cains",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "2DCELL",
    currentJob: "2D Welding",
    lastUpdated: "2026-05-08 13:33",
    tagBatteryPct: 95,
    indirectMinutes: 10,
    avgTaskDurationMins: 57,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043318",
        status: "Completed",
        duration: "118m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043325",
        status: "Completed",
        duration: "60m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043333",
        status: "Completed",
        duration: "96m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043341",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["WELD", "SAW", "2DCELL"],
      totalActiveTime: "6h 10m",
      totalIdleTime: "0h 18m",
    },
  },
  {
    employeeId: "105043",
    fullName: "Justin Francis",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "2DCELL",
    currentJob: "2D Material Handling",
    lastUpdated: "2026-05-08 13:40",
    tagBatteryPct: 92,
    indirectMinutes: 10,
    avgTaskDurationMins: 53,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043348",
        status: "Completed",
        duration: "54m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043356",
        status: "Completed",
        duration: "115m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043363",
        status: "Completed",
        duration: "58m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043371",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["SAW", "2DCELL"],
      totalActiveTime: "5h 50m",
      totalIdleTime: "0h 30m",
    },
  },
  {
    employeeId: "C100278",
    fullName: "Stephen Goldberg",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "2DCELL",
    currentJob: "2D Welding",
    lastUpdated: "2026-05-08 13:47",
    tagBatteryPct: 90,
    indirectMinutes: 10,
    avgTaskDurationMins: 56,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043377",
        status: "Completed",
        duration: "110m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043385",
        status: "Completed",
        duration: "56m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043392",
        status: "Completed",
        duration: "102m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043400",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WELD", "SAW", "2DCELL"],
      totalActiveTime: "5h 58m",
      totalIdleTime: "0h 26m",
    },
  },
  {
    employeeId: "100987",
    fullName: "Pablo Leon",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "2DCELL",
    currentJob: "2D Material Handling",
    lastUpdated: "2026-05-08 13:52",
    tagBatteryPct: 96,
    indirectMinutes: 10,
    avgTaskDurationMins: 55,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043406",
        status: "Completed",
        duration: "108m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043414",
        status: "Completed",
        duration: "63m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043421",
        status: "Completed",
        duration: "97m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043429",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["SAW", "2DCELL"],
      totalActiveTime: "5h 46m",
      totalIdleTime: "0h 34m",
    },
  },
  {
    employeeId: "101022",
    fullName: "Efren Ortiz",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "2DCELL",
    currentJob: "2D Welding",
    lastUpdated: "2026-05-08 13:58",
    tagBatteryPct: 93,
    indirectMinutes: 10,
    avgTaskDurationMins: 57,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043435",
        status: "Completed",
        duration: "61m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043443",
        status: "Completed",
        duration: "114m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043450",
        status: "Completed",
        duration: "55m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043458",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WELD", "SAW", "2DCELL"],
      totalActiveTime: "6h 05m",
      totalIdleTime: "0h 19m",
    },
  },
  {
    employeeId: "101027",
    fullName: "Dominic Perreault",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "2DCELL",
    currentJob: "2D Material Handling",
    lastUpdated: "2026-05-08 13:44",
    tagBatteryPct: 91,
    indirectMinutes: 10,
    avgTaskDurationMins: 54,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043464",
        status: "Completed",
        duration: "120m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043472",
        status: "Completed",
        duration: "57m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043479",
        status: "Completed",
        duration: "91m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043487",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["SAW", "2DCELL"],
      totalActiveTime: "5h 53m",
      totalIdleTime: "0h 31m",
    },
  },
  {
    employeeId: "101030",
    fullName: "Leighton Pittmann",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "2DCELL",
    currentJob: "2D Welding",
    lastUpdated: "2026-05-08 13:37",
    tagBatteryPct: 94,
    indirectMinutes: 10,
    avgTaskDurationMins: 56,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043493",
        status: "Completed",
        duration: "113m",
      },
      {
        jobName: "2D Material Handling",
        jobId: "JOB000043501",
        status: "Completed",
        duration: "58m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043508",
        status: "Completed",
        duration: "99m",
      },
      {
        jobName: "2D Welding",
        jobId: "JOB000043516",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["WELD", "SAW", "2DCELL"],
      totalActiveTime: "6h 00m",
      totalIdleTime: "0h 24m",
    },
  },
  // ── SAW zone (25% = 4 employees) ──────────────────
  {
    employeeId: "105383",
    fullName: "Christopher Sanchez",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "SAW",
    currentJob: "2D Saw Operation",
    lastUpdated: "2026-05-08 13:22",
    tagBatteryPct: 97,
    indirectMinutes: 10,
    avgTaskDurationMins: 60,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Saw Operation",
        jobId: "JOB000043522",
        status: "Completed",
        duration: "175m",
      },
      {
        jobName: "2D Saw Operation",
        jobId: "JOB000043530",
        status: "Completed",
        duration: "183m",
      },
      {
        jobName: "2D Saw Operation",
        jobId: "JOB000043538",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["SAW"],
      totalActiveTime: "6h 12m",
      totalIdleTime: "0h 12m",
    },
  },
  {
    employeeId: "101049",
    fullName: "Carter Snell",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "SAW",
    currentJob: "2D Saw Operation",
    lastUpdated: "2026-05-08 13:30",
    tagBatteryPct: 93,
    indirectMinutes: 10,
    avgTaskDurationMins: 59,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Saw Operation",
        jobId: "JOB000043544",
        status: "Completed",
        duration: "168m",
      },
      {
        jobName: "2D Saw Operation",
        jobId: "JOB000043552",
        status: "Completed",
        duration: "177m",
      },
      {
        jobName: "2D Saw Operation",
        jobId: "JOB000043560",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["SAW"],
      totalActiveTime: "6h 05m",
      totalIdleTime: "0h 19m",
    },
  },
  {
    employeeId: "105385",
    fullName: "Trayveon Vasser",
    department: "2D/Saw",
    team: "2D/SAW",
    currentZone: "SAW",
    currentJob: "2D Saw Operation",
    lastUpdated: "2026-05-08 13:48",
    tagBatteryPct: 90,
    indirectMinutes: 10,
    avgTaskDurationMins: 62,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "2D Saw Operation",
        jobId: "JOB000043566",
        status: "Completed",
        duration: "182m",
      },
      {
        jobName: "2D Saw Operation",
        jobId: "JOB000043574",
        status: "Completed",
        duration: "190m",
      },
      {
        jobName: "2D Saw Operation",
        jobId: "JOB000043581",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["SAW"],
      totalActiveTime: "6h 18m",
      totalIdleTime: "0h 06m",
    },
  },
  // ─────────────────────────────────────────────
  // TEAM: BLUCO  (15 employees)
  // Zone rule: 4 max → ROBOT area, rest → Station 4-20
  // Base pattern: Hailey Spence (CW100308) — 3D Finish Welding / Manual Jig Volumetric Weld
  // ─────────────────────────────────────────────
  {
    employeeId: "103785",
    fullName: "Josef Eid",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "ROBOT",
    currentJob: "3D Finish Welding",
    lastUpdated: "2026-05-08 13:06",
    tagBatteryPct: 97,
    indirectMinutes: 10,
    avgTaskDurationMins: 44,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041601",
        status: "Completed",
        duration: "198m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041609",
        status: "Completed",
        duration: "210m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041617",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["ROBOT", "WELD"],
      totalActiveTime: "6h 18m",
      totalIdleTime: "0h 06m",
    },
  },
  {
    employeeId: "100949",
    fullName: "Nathanael Esper",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "ROBOT",
    currentJob: "Manual Jig Volumetric Weld",
    lastUpdated: "2026-05-08 13:14",
    tagBatteryPct: 94,
    indirectMinutes: 10,
    avgTaskDurationMins: 42,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041623",
        status: "Completed",
        duration: "204m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041631",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["ROBOT", "WELD"],
      totalActiveTime: "6h 08m",
      totalIdleTime: "0h 14m",
    },
  },
  {
    employeeId: "104674",
    fullName: "Armando Gomez",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "ROBOT",
    currentJob: "3D Finish Welding",
    lastUpdated: "2026-05-08 13:21",
    tagBatteryPct: 91,
    indirectMinutes: 10,
    avgTaskDurationMins: 43,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041637",
        status: "Completed",
        duration: "215m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041645",
        status: "Completed",
        duration: "193m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041653",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["ROBOT", "WELD"],
      totalActiveTime: "6h 22m",
      totalIdleTime: "0h 02m",
    },
  },
  {
    employeeId: "CW100353",
    fullName: "Justin Littlewhirlwind",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "ROBOT",
    currentJob: "Manual Jig Volumetric Weld",
    lastUpdated: "2026-05-08 13:29",
    tagBatteryPct: 98,
    indirectMinutes: 10,
    avgTaskDurationMins: 41,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041659",
        status: "Completed",
        duration: "207m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041667",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["ROBOT", "WELD"],
      totalActiveTime: "6h 02m",
      totalIdleTime: "0h 20m",
    },
  },
  // ── Station zone (11 employees) ───────────────────
  {
    employeeId: "104838",
    fullName: "Devon Menjivar",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "Station 5",
    currentJob: "3D Finish Welding",
    lastUpdated: "2026-05-08 13:07",
    tagBatteryPct: 96,
    indirectMinutes: 10,
    avgTaskDurationMins: 43,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041673",
        status: "Completed",
        duration: "201m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041681",
        status: "Completed",
        duration: "188m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041689",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 4", "Station 5"],
      totalActiveTime: "6h 14m",
      totalIdleTime: "0h 10m",
    },
  },
  {
    employeeId: "105269",
    fullName: "Joshua Mitchell",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "Station 7",
    currentJob: "Manual Jig Volumetric Weld",
    lastUpdated: "2026-05-08 13:15",
    tagBatteryPct: 93,
    indirectMinutes: 10,
    avgTaskDurationMins: 42,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041695",
        status: "Completed",
        duration: "196m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041703",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 6", "Station 7"],
      totalActiveTime: "6h 05m",
      totalIdleTime: "0h 17m",
    },
  },
  {
    employeeId: "101014",
    fullName: "Braden Munday",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "Station 9",
    currentJob: "3D Finish Welding",
    lastUpdated: "2026-05-08 13:22",
    tagBatteryPct: 90,
    indirectMinutes: 10,
    avgTaskDurationMins: 44,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041709",
        status: "Completed",
        duration: "211m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041717",
        status: "Completed",
        duration: "199m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041725",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["Station 8", "Station 9"],
      totalActiveTime: "6h 20m",
      totalIdleTime: "0h 04m",
    },
  },
  {
    employeeId: "101020",
    fullName: "Seth Ornelas",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "Station 11",
    currentJob: "Manual Jig Volumetric Weld",
    lastUpdated: "2026-05-08 13:31",
    tagBatteryPct: 95,
    indirectMinutes: 10,
    avgTaskDurationMins: 41,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041731",
        status: "Completed",
        duration: "202m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041739",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 10", "Station 11"],
      totalActiveTime: "6h 00m",
      totalIdleTime: "0h 22m",
    },
  },
  {
    employeeId: "101028",
    fullName: "Alexander Perry",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "Station 13",
    currentJob: "3D Finish Welding",
    lastUpdated: "2026-05-08 13:38",
    tagBatteryPct: 92,
    indirectMinutes: 10,
    avgTaskDurationMins: 43,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041745",
        status: "Completed",
        duration: "208m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041753",
        status: "Completed",
        duration: "194m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041761",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 12", "Station 13"],
      totalActiveTime: "6h 16m",
      totalIdleTime: "0h 08m",
    },
  },
  {
    employeeId: "101033",
    fullName: "Donald Puterbaugh",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "Station 15",
    currentJob: "Manual Jig Volumetric Weld",
    lastUpdated: "2026-05-08 13:45",
    tagBatteryPct: 97,
    indirectMinutes: 10,
    avgTaskDurationMins: 42,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041767",
        status: "Completed",
        duration: "197m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041775",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 14", "Station 15"],
      totalActiveTime: "6h 03m",
      totalIdleTime: "0h 19m",
    },
  },
  {
    employeeId: "101035",
    fullName: "Rowan Ripley",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "Station 17",
    currentJob: "3D Finish Welding",
    lastUpdated: "2026-05-08 13:52",
    tagBatteryPct: 90,
    indirectMinutes: 10,
    avgTaskDurationMins: 44,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041781",
        status: "Completed",
        duration: "213m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041789",
        status: "Completed",
        duration: "191m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041797",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 16", "Station 17"],
      totalActiveTime: "6h 18m",
      totalIdleTime: "0h 06m",
    },
  },
  {
    employeeId: "CW100295",
    fullName: "Jose Saenz",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "Station 19",
    currentJob: "Manual Jig Volumetric Weld",
    lastUpdated: "2026-05-08 13:59",
    tagBatteryPct: 94,
    indirectMinutes: 10,
    avgTaskDurationMins: 42,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041803",
        status: "Completed",
        duration: "205m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041811",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 18", "Station 19"],
      totalActiveTime: "6h 07m",
      totalIdleTime: "0h 15m",
    },
  },
  {
    employeeId: "101069",
    fullName: "Andrew Wise",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "Station 4",
    currentJob: "3D Finish Welding",
    lastUpdated: "2026-05-08 13:53",
    tagBatteryPct: 96,
    indirectMinutes: 10,
    avgTaskDurationMins: 43,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041823",
        status: "Completed",
        duration: "209m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041831",
        status: "Completed",
        duration: "195m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041839",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 4", "Station 5"],
      totalActiveTime: "6h 15m",
      totalIdleTime: "0h 09m",
    },
  },
  {
    employeeId: "105046",
    fullName: "Sophie Young",
    department: "Bluco",
    team: "BLUCO",
    currentZone: "Station 6",
    currentJob: "Manual Jig Volumetric Weld",
    lastUpdated: "2026-05-08 13:57",
    tagBatteryPct: 91,
    indirectMinutes: 10,
    avgTaskDurationMins: 42,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "3D Finish Welding",
        jobId: "JOB000041845",
        status: "Completed",
        duration: "200m",
      },
      {
        jobName: "Manual Jig Volumetric Weld",
        jobId: "JOB000041853",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 5", "Station 6"],
      totalActiveTime: "6h 04m",
      totalIdleTime: "0h 18m",
    },
  },

  {
    employeeId: "100930",
    fullName: "Gloria Calleros",
    department: "Wall Build",
    team: "Wall Build",
    currentZone: "WALL BUILD",
    currentJob: "Wall Panel Assembly",
    lastUpdated: "2026-05-08 13:12",
    tagBatteryPct: 93,
    indirectMinutes: 10,
    avgTaskDurationMins: 49,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045048",
        status: "Completed",
        duration: "145m",
      },
      {
        jobName: "No Active Registration",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045055",
        status: "Completed",
        duration: "218m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045062",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WALL BUILD"],
      totalActiveTime: "6h 15m",
      totalIdleTime: "0h 18m",
    },
  },
  {
    employeeId: "100932",
    fullName: "Maria Carmona",
    department: "Wall Build",
    team: "Wall Build",
    currentZone: "WALL BUILD",
    currentJob: "FRAME CAD, fabrication/assy",
    lastUpdated: "2026-05-08 13:19",
    tagBatteryPct: 97,
    indirectMinutes: 10,
    avgTaskDurationMins: 52,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045068",
        status: "Completed",
        duration: "161m",
      },
      {
        jobName: "No Active Registration",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045075",
        status: "Completed",
        duration: "221m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045082",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WALL BUILD"],
      totalActiveTime: "6h 30m",
      totalIdleTime: "0h 08m",
    },
  },
  {
    employeeId: "104743",
    fullName: "Malachi Derichsweiler",
    department: "Wall Build",
    team: "Wall Build",
    currentZone: "WALL BUILD",
    currentJob: "Wall Panel Assembly",
    lastUpdated: "2026-05-08 13:26",
    tagBatteryPct: 91,
    indirectMinutes: 10,
    avgTaskDurationMins: 50,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045088",
        status: "Completed",
        duration: "148m",
      },
      {
        jobName: "No Active Registration",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045095",
        status: "Completed",
        duration: "230m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045102",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WALL BUILD"],
      totalActiveTime: "6h 18m",
      totalIdleTime: "0h 15m",
    },
  },
  {
    employeeId: "103374",
    fullName: "Jose Gonzalez",
    department: "Wall Build",
    team: "Wall Build",
    currentZone: "WALL BUILD",
    currentJob: "FRAME CAD, fabrication/assy",
    lastUpdated: "2026-05-08 13:33",
    tagBatteryPct: 94,
    indirectMinutes: 10,
    avgTaskDurationMins: 53,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045108",
        status: "Completed",
        duration: "158m",
      },
      {
        jobName: "No Active Registration",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045115",
        status: "Completed",
        duration: "235m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045122",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["WALL BUILD"],
      totalActiveTime: "6h 25m",
      totalIdleTime: "0h 12m",
    },
  },
  {
    employeeId: "100968",
    fullName: "Nestor Gutierrez",
    department: "Wall Build",
    team: "Wall Build",
    currentZone: "WALL BUILD",
    currentJob: "Wall Panel Assembly",
    lastUpdated: "2026-05-08 13:40",
    tagBatteryPct: 98,
    indirectMinutes: 10,
    avgTaskDurationMins: 50,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045128",
        status: "Completed",
        duration: "152m",
      },
      {
        jobName: "No Active Registration",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045135",
        status: "Completed",
        duration: "224m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045142",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WALL BUILD"],
      totalActiveTime: "6h 20m",
      totalIdleTime: "0h 13m",
    },
  },
  {
    employeeId: "104842",
    fullName: "Jose Holguin",
    department: "Wall Build",
    team: "Wall Build",
    currentZone: "WALL BUILD",
    currentJob: "FRAME CAD, fabrication/assy",
    lastUpdated: "2026-05-08 13:47",
    tagBatteryPct: 92,
    indirectMinutes: 10,
    avgTaskDurationMins: 51,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045148",
        status: "Completed",
        duration: "156m",
      },
      {
        jobName: "No Active Registration",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045155",
        status: "Completed",
        duration: "227m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045162",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WALL BUILD"],
      totalActiveTime: "6h 22m",
      totalIdleTime: "0h 11m",
    },
  },
  {
    employeeId: "100991",
    fullName: "Armond Littleton",
    department: "Wall Build",
    team: "Wall Build",
    currentZone: "WALL BUILD",
    currentJob: "Wall Panel Assembly",
    lastUpdated: "2026-05-08 13:54",
    tagBatteryPct: 96,
    indirectMinutes: 10,
    avgTaskDurationMins: 49,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045168",
        status: "Completed",
        duration: "143m",
      },
      {
        jobName: "No Active Registration",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045175",
        status: "Completed",
        duration: "215m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045182",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WALL BUILD"],
      totalActiveTime: "6h 12m",
      totalIdleTime: "0h 21m",
    },
  },
  {
    employeeId: "101000",
    fullName: "Ramon Martinez Sr",
    department: "Wall Build",
    team: "Wall Build",
    currentZone: "WALL BUILD",
    currentJob: "FRAME CAD, fabrication/assy",
    lastUpdated: "2026-05-08 13:36",
    tagBatteryPct: 90,
    indirectMinutes: 10,
    avgTaskDurationMins: 52,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045188",
        status: "Completed",
        duration: "163m",
      },
      {
        jobName: "No Active Registration",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045195",
        status: "Completed",
        duration: "231m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045202",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WALL BUILD"],
      totalActiveTime: "6h 28m",
      totalIdleTime: "0h 09m",
    },
  },
  {
    employeeId: "101001",
    fullName: "Margarito Mauricio",
    department: "Wall Build",
    team: "Wall Build",
    currentZone: "WALL BUILD",
    currentJob: "Wall Panel Assembly",
    lastUpdated: "2026-05-08 13:43",
    tagBatteryPct: 93,
    indirectMinutes: 10,
    avgTaskDurationMins: 50,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045208",
        status: "Completed",
        duration: "149m",
      },
      {
        jobName: "No Active Registration",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045215",
        status: "Completed",
        duration: "220m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045222",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WALL BUILD"],
      totalActiveTime: "6h 17m",
      totalIdleTime: "0h 16m",
    },
  },
  {
    employeeId: "101055",
    fullName: "Everardo Suarez",
    department: "Wall Build",
    team: "Wall Build",
    currentZone: "WALL BUILD",
    currentJob: "FRAME CAD, fabrication/assy",
    lastUpdated: "2026-05-08 13:50",
    tagBatteryPct: 97,
    indirectMinutes: 10,
    avgTaskDurationMins: 51,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045228",
        status: "Completed",
        duration: "155m",
      },
      {
        jobName: "No Active Registration",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045235",
        status: "Completed",
        duration: "226m",
      },
      {
        jobName: "FRAME CAD, fabrication/assy",
        jobId: "JOB000045242",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["WALL BUILD"],
      totalActiveTime: "6h 24m",
      totalIdleTime: "0h 09m",
    },
  },
  {
    employeeId: "101072",
    fullName: "Joel Worley",
    department: "Wall Build",
    team: "Wall Build",
    currentZone: "WALL BUILD",
    currentJob: "Wall Panel Assembly",
    lastUpdated: "2026-05-08 13:57",
    tagBatteryPct: 91,
    indirectMinutes: 10,
    avgTaskDurationMins: 50,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045248",
        status: "Completed",
        duration: "147m",
      },
      {
        jobName: "No Active Registration",
        jobId: "JOB000030911",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045255",
        status: "Completed",
        duration: "222m",
      },
      {
        jobName: "Wall Panel Assembly",
        jobId: "JOB000045262",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["WALL BUILD"],
      totalActiveTime: "6h 19m",
      totalIdleTime: "0h 14m",
    },
  },
  {
    employeeId: "103420",
    fullName: "Isaac Campillo",
    department: "FWB",
    team: "FWB",
    currentZone: "DECK",
    currentJob: "Exterior Wall Install",
    lastUpdated: "2026-05-08 13:16",
    tagBatteryPct: 93,
    indirectMinutes: 5,
    avgTaskDurationMins: 54,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043615",
        status: "Completed",
        duration: "24m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043622",
        status: "Completed",
        duration: "112m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043630",
        status: "Completed",
        duration: "129m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043638",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["DECK"],
      totalActiveTime: "6h 22m",
      totalIdleTime: "1h 04m",
    },
  },
  // ── Station zone (12 employees) ───────────────────
  {
    employeeId: "100931",
    fullName: "Joseph Campillo",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 4",
    currentJob: "Sub-FLooring Install",
    lastUpdated: "2026-05-08 13:24",
    tagBatteryPct: 97,
    indirectMinutes: 5,
    avgTaskDurationMins: 53,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043644",
        status: "Completed",
        duration: "20m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043651",
        status: "Completed",
        duration: "115m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043659",
        status: "Completed",
        duration: "122m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043667",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 4", "Station 5"],
      totalActiveTime: "6h 30m",
      totalIdleTime: "0h 56m",
    },
  },
  {
    employeeId: "100956",
    fullName: "Anthony Garcia",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 5",
    currentJob: "Exterior Wall Install",
    lastUpdated: "2026-05-08 13:31",
    tagBatteryPct: 91,
    indirectMinutes: 4,
    avgTaskDurationMins: 54,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043673",
        status: "Completed",
        duration: "21m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043680",
        status: "Completed",
        duration: "109m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043688",
        status: "Completed",
        duration: "131m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043696",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 4", "Station 5"],
      totalActiveTime: "6h 18m",
      totalIdleTime: "1h 08m",
    },
  },
  {
    employeeId: "103646",
    fullName: "Juan Godinez",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 6",
    currentJob: "Sub-FLooring Install",
    lastUpdated: "2026-05-08 13:38",
    tagBatteryPct: 95,
    indirectMinutes: 5,
    avgTaskDurationMins: 52,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043702",
        status: "Completed",
        duration: "23m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043709",
        status: "Completed",
        duration: "117m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043717",
        status: "Completed",
        duration: "120m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043725",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 5", "Station 6"],
      totalActiveTime: "6h 25m",
      totalIdleTime: "1h 01m",
    },
  },
  {
    employeeId: "100984",
    fullName: "Matthew Johnson",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 8",
    currentJob: "Sub-FLooring Install",
    lastUpdated: "2026-05-08 13:52",
    tagBatteryPct: 92,
    indirectMinutes: 5,
    avgTaskDurationMins: 53,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043761",
        status: "Completed",
        duration: "19m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043768",
        status: "Completed",
        duration: "113m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043776",
        status: "Completed",
        duration: "123m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043784",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 7", "Station 8"],
      totalActiveTime: "6h 20m",
      totalIdleTime: "1h 06m",
    },
  },
  {
    employeeId: "104212",
    fullName: "Alonzo Lopez",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 9",
    currentJob: "Exterior Wall Install",
    lastUpdated: "2026-05-08 13:07",
    tagBatteryPct: 94,
    indirectMinutes: 4,
    avgTaskDurationMins: 54,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043790",
        status: "Completed",
        duration: "22m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043797",
        status: "Completed",
        duration: "110m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043805",
        status: "Completed",
        duration: "128m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043813",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 8", "Station 9"],
      totalActiveTime: "6h 16m",
      totalIdleTime: "1h 10m",
    },
  },
  {
    employeeId: "103821",
    fullName: "Jesse Marquez",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 10",
    currentJob: "Sub-FLooring Install",
    lastUpdated: "2026-05-08 13:14",
    tagBatteryPct: 90,
    indirectMinutes: 5,
    avgTaskDurationMins: 52,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043819",
        status: "Completed",
        duration: "21m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043827",
        status: "Completed",
        duration: "116m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043835",
        status: "Completed",
        duration: "121m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043843",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 9", "Station 10"],
      totalActiveTime: "6h 27m",
      totalIdleTime: "0h 59m",
    },
  },
  {
    employeeId: "104675",
    fullName: "Arturo Morales",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 11",
    currentJob: "Exterior Wall Install",
    lastUpdated: "2026-05-08 13:22",
    tagBatteryPct: 96,
    indirectMinutes: 4,
    avgTaskDurationMins: 54,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043849",
        status: "Completed",
        duration: "20m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043856",
        status: "Completed",
        duration: "111m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043864",
        status: "Completed",
        duration: "130m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043872",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["Station 10", "Station 11"],
      totalActiveTime: "6h 14m",
      totalIdleTime: "1h 12m",
    },
  },
  {
    employeeId: "103701",
    fullName: "Travis Nez",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 12",
    currentJob: "Sub-FLooring Install",
    lastUpdated: "2026-05-08 13:29",
    tagBatteryPct: 91,
    indirectMinutes: 5,
    avgTaskDurationMins: 53,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043878",
        status: "Completed",
        duration: "23m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043885",
        status: "Completed",
        duration: "119m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043893",
        status: "Completed",
        duration: "124m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043901",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 11", "Station 12"],
      totalActiveTime: "6h 32m",
      totalIdleTime: "0h 54m",
    },
  },
  {
    employeeId: "101026",
    fullName: "Thomas Perez",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 13",
    currentJob: "Exterior Wall Install",
    lastUpdated: "2026-05-08 13:36",
    tagBatteryPct: 93,
    indirectMinutes: 4,
    avgTaskDurationMins: 54,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043907",
        status: "Completed",
        duration: "21m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043914",
        status: "Completed",
        duration: "108m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043922",
        status: "Completed",
        duration: "126m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043930",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 12", "Station 13"],
      totalActiveTime: "6h 10m",
      totalIdleTime: "1h 16m",
    },
  },
  {
    employeeId: "101031",
    fullName: "Lowell Plandes",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 14",
    currentJob: "Sub-FLooring Install",
    lastUpdated: "2026-05-08 13:43",
    tagBatteryPct: 97,
    indirectMinutes: 5,
    avgTaskDurationMins: 52,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043936",
        status: "Completed",
        duration: "22m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043943",
        status: "Completed",
        duration: "114m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043951",
        status: "Completed",
        duration: "121m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043959",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 13", "Station 14"],
      totalActiveTime: "6h 24m",
      totalIdleTime: "1h 02m",
    },
  },
  {
    employeeId: "103916",
    fullName: "Demarien Smith",
    department: "FWB",
    team: "FWB",
    currentZone: "Station 15",
    currentJob: "Exterior Wall Install",
    lastUpdated: "2026-05-08 13:51",
    tagBatteryPct: 90,
    indirectMinutes: 4,
    avgTaskDurationMins: 54,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043965",
        status: "Completed",
        duration: "20m",
      },
      {
        jobName: "Sub-FLooring Install",
        jobId: "JOB000043972",
        status: "Completed",
        duration: "106m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043980",
        status: "Completed",
        duration: "127m",
      },
      {
        jobName: "Exterior Wall Install",
        jobId: "JOB000043988",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 14", "Station 15"],
      totalActiveTime: "6h 08m",
      totalIdleTime: "1h 18m",
    },
  },
  {
    employeeId: "104672",
    fullName: "Andres Arrieta",
    department: "HVAC",
    team: "HVAC",
    currentZone: "Station 5",
    currentJob: "Fire Protection / Sprinkler",
    lastUpdated: "2026-05-08 13:07",
    tagBatteryPct: 95,
    indirectMinutes: 10,
    avgTaskDurationMins: 65,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000046301",
        status: "Completed",
        duration: "95m",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000046314",
        status: "Completed",
        duration: "298m",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000046328",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 4", "Station 5"],
      totalActiveTime: "4h 22m",
      totalIdleTime: "1h 06m",
    },
  },
  {
    employeeId: "100919",
    fullName: "Edgar Atienzo",
    department: "HVAC",
    team: "HVAC",
    currentZone: "Station 8",
    currentJob: "HVAC Rough-In",
    lastUpdated: "2026-05-08 13:19",
    tagBatteryPct: 92,
    indirectMinutes: 10,
    avgTaskDurationMins: 68,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000046334",
        status: "Completed",
        duration: "102m",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000046341",
        status: "Completed",
        duration: "308m",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000046349",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 7", "Station 8"],
      totalActiveTime: "4h 30m",
      totalIdleTime: "1h 00m",
    },
  },
  {
    employeeId: "100961",
    fullName: "Brok Glazewski",
    department: "HVAC",
    team: "HVAC",
    currentZone: "Station 11",
    currentJob: "Mechanical Rough-In",
    lastUpdated: "2026-05-08 13:31",
    tagBatteryPct: 98,
    indirectMinutes: 10,
    avgTaskDurationMins: 66,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Fire Protection / Sprinkler",
        jobId: "JOB000046355",
        status: "Completed",
        duration: "99m",
      },
      {
        jobName: "Mechanical Rough-In",
        jobId: "JOB000046362",
        status: "Completed",
        duration: "295m",
      },
      {
        jobName: "Mechanical Rough-In",
        jobId: "JOB000046370",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["Station 10", "Station 11"],
      totalActiveTime: "4h 18m",
      totalIdleTime: "1h 10m",
    },
  },
  {
    employeeId: "C100217",
    fullName: "Thomas Rodriguez",
    department: "HVAC",
    team: "HVAC",
    currentZone: "Station 17",
    currentJob: "HVAC Rough-In",
    lastUpdated: "2026-05-08 13:55",
    tagBatteryPct: 90,
    indirectMinutes: 10,
    avgTaskDurationMins: 66,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Mechanical Rough-In",
        jobId: "JOB000046382",
        status: "Completed",
        duration: "101m",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000046389",
        status: "Completed",
        duration: "304m",
      },
      {
        jobName: "HVAC Rough-In",
        jobId: "JOB000046397",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 16", "Station 17"],
      totalActiveTime: "4h 20m",
      totalIdleTime: "1h 08m",
    },
  },
  {
    employeeId: "105382",
    fullName: "Weston Calta",
    department: "Plumbing",
    team: "PLUMB",
    currentZone: "Station 4",
    currentJob: "Plumbing Rough-In",
    lastUpdated: "2026-05-08 13:06",
    tagBatteryPct: 96,
    indirectMinutes: 10,
    avgTaskDurationMins: 155,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044801",
        status: "Completed",
        duration: "152m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044812",
        status: "Completed",
        duration: "158m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044823",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 4", "Station 5"],
      totalActiveTime: "6h 38m",
      totalIdleTime: "0h 30m",
    },
  },
  {
    employeeId: "103775",
    fullName: "Ricardo Fonseca",
    department: "Plumbing",
    team: "PLUMB",
    currentZone: "Station 6",
    currentJob: "Plumbing Rough-In",
    lastUpdated: "2026-05-08 13:14",
    tagBatteryPct: 93,
    indirectMinutes: 10,
    avgTaskDurationMins: 160,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044829",
        status: "Completed",
        duration: "159m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044837",
        status: "Completed",
        duration: "163m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044845",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 5", "Station 6"],
      totalActiveTime: "6h 44m",
      totalIdleTime: "0h 24m",
    },
  },
  {
    employeeId: "100969",
    fullName: "Zachary Hall",
    department: "Plumbing",
    team: "PLUMB",
    currentZone: "Station 8",
    currentJob: "Final Plumbing",
    lastUpdated: "2026-05-08 13:22",
    tagBatteryPct: 97,
    indirectMinutes: 10,
    avgTaskDurationMins: 157,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044851",
        status: "Completed",
        duration: "154m",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000044859",
        status: "Completed",
        duration: "161m",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000044867",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 7", "Station 8"],
      totalActiveTime: "6h 40m",
      totalIdleTime: "0h 28m",
    },
  },
  {
    employeeId: "101011",
    fullName: "Tania Moreira",
    department: "Plumbing",
    team: "PLUMB",
    currentZone: "Station 13",
    currentJob: "Plumbing Trim-Out",
    lastUpdated: "2026-05-08 13:39",
    tagBatteryPct: 91,
    indirectMinutes: 10,
    avgTaskDurationMins: 156,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044879",
        status: "Completed",
        duration: "150m",
      },
      {
        jobName: "Plumbing Trim-Out",
        jobId: "JOB000044887",
        status: "Completed",
        duration: "163m",
      },
      {
        jobName: "Plumbing Trim-Out",
        jobId: "JOB000044895",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 12", "Station 13"],
      totalActiveTime: "6h 36m",
      totalIdleTime: "0h 32m",
    },
  },
  {
    employeeId: "104543",
    fullName: "Dylan Porto",
    department: "Plumbing",
    team: "PLUMB",
    currentZone: "Station 15",
    currentJob: "Plumbing Rough-In",
    lastUpdated: "2026-05-08 13:47",
    tagBatteryPct: 94,
    indirectMinutes: 10,
    avgTaskDurationMins: 159,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044901",
        status: "Completed",
        duration: "157m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044909",
        status: "Completed",
        duration: "164m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044917",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["Station 14", "Station 15"],
      totalActiveTime: "6h 46m",
      totalIdleTime: "0h 22m",
    },
  },
  {
    employeeId: "101073",
    fullName: "Francisco Zainos",
    department: "Plumbing",
    team: "PLUMB",
    currentZone: "Station 17",
    currentJob: "Final Plumbing",
    lastUpdated: "2026-05-08 13:55",
    tagBatteryPct: 90,
    indirectMinutes: 10,
    avgTaskDurationMins: 157,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Plumbing Rough-In",
        jobId: "JOB000044923",
        status: "Completed",
        duration: "153m",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000044931",
        status: "Completed",
        duration: "162m",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000044939",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 16", "Station 17"],
      totalActiveTime: "6h 40m",
      totalIdleTime: "0h 28m",
    },
  },

  {
    employeeId: "103373",
    fullName: "Brandon Brock",
    department: "Interior Drywall",
    team: "INT. DRYWALL",
    currentZone: "Station 6",
    currentJob: "Gypsum and Install Boundary/Upper Ceiling",
    lastUpdated: "2026-05-08 13:08",
    tagBatteryPct: 96,
    indirectMinutes: 10,
    avgTaskDurationMins: 190,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000044901",
        status: "Completed",
        duration: "188m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000044908",
        status: "Completed",
        duration: "194m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000044915",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 5", "Station 6"],
      totalActiveTime: "5h 22m",
      totalIdleTime: "0h 30m",
    },
  },
  {
    employeeId: "100935",
    fullName: "Kevin Castillo",
    department: "Interior Drywall",
    team: "INT. DRYWALL",
    currentZone: "Station 8",
    currentJob: "Drywall Hang",
    lastUpdated: "2026-05-08 13:16",
    tagBatteryPct: 93,
    indirectMinutes: 10,
    avgTaskDurationMins: 192,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000044921",
        status: "Completed",
        duration: "191m",
      },
      {
        jobName: "Drywall Hang",
        jobId: "JOB000044928",
        status: "Completed",
        duration: "195m",
      },
      {
        jobName: "Drywall Hang",
        jobId: "JOB000044935",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 7", "Station 8"],
      totalActiveTime: "5h 34m",
      totalIdleTime: "0h 22m",
    },
  },
  {
    employeeId: "105380",
    fullName: "Antonio Edwards",
    department: "Interior Drywall",
    team: "INT. DRYWALL",
    currentZone: "Station 10",
    currentJob: "Gypsum and Install Boundary/Upper Ceiling",
    lastUpdated: "2026-05-08 13:24",
    tagBatteryPct: 97,
    indirectMinutes: 10,
    avgTaskDurationMins: 189,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Drywall Hang",
        jobId: "JOB000044941",
        status: "Completed",
        duration: "185m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000044948",
        status: "Completed",
        duration: "192m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000044955",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 9", "Station 10"],
      totalActiveTime: "5h 28m",
      totalIdleTime: "0h 26m",
    },
  },
  {
    employeeId: "100959",
    fullName: "Myriah Gass",
    department: "Interior Drywall",
    team: "INT. DRYWALL",
    currentZone: "Station 12",
    currentJob: "Tape and Mud",
    lastUpdated: "2026-05-08 13:32",
    tagBatteryPct: 91,
    indirectMinutes: 10,
    avgTaskDurationMins: 191,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000044961",
        status: "Completed",
        duration: "193m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044968",
        status: "Completed",
        duration: "189m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044975",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["Station 11", "Station 12"],
      totalActiveTime: "5h 36m",
      totalIdleTime: "0h 20m",
    },
  },

  {
    employeeId: "101023",
    fullName: "Martin Ortiz Corona",
    department: "Interior Drywall",
    team: "INT. DRYWALL",
    currentZone: "Station 16",
    currentJob: "Drywall Hang",
    lastUpdated: "2026-05-08 13:48",
    tagBatteryPct: 92,
    indirectMinutes: 10,
    avgTaskDurationMins: 188,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000045001",
        status: "Completed",
        duration: "186m",
      },
      {
        jobName: "Drywall Hang",
        jobId: "JOB000045008",
        status: "Completed",
        duration: "191m",
      },
      {
        jobName: "Drywall Hang",
        jobId: "JOB000045015",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 15", "Station 16"],
      totalActiveTime: "5h 25m",
      totalIdleTime: "0h 31m",
    },
  },
  {
    employeeId: "101074",
    fullName: "Adrian Roque",
    department: "Interior Drywall",
    team: "INT. DRYWALL",
    currentZone: "Station 18",
    currentJob: "Gypsum and Install Boundary/Upper Ceiling",
    lastUpdated: "2026-05-08 13:56",
    tagBatteryPct: 90,
    indirectMinutes: 10,
    avgTaskDurationMins: 190,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Drywall Hang",
        jobId: "JOB000045021",
        status: "Completed",
        duration: "187m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000045028",
        status: "Completed",
        duration: "196m",
      },
      {
        jobName: "Gypsum and Install Boundary/Upper Ceiling",
        jobId: "JOB000045035",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 17", "Station 18"],
      totalActiveTime: "5h 32m",
      totalIdleTime: "0h 24m",
    },
  },
  {
    employeeId: "104546",
    fullName: "Andrew Amado",
    department: "TNT",
    team: "TNT",
    currentZone: "PAINT",
    currentJob: "Paint Interior",
    lastUpdated: "2026-05-08 13:05",
    tagBatteryPct: 96,
    indirectMinutes: 6,
    avgTaskDurationMins: 44,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044501",
        status: "Completed",
        duration: "211m",
      },
      {
        jobName: "Paint Interior",
        jobId: "JOB000044508",
        status: "Completed",
        duration: "206m",
      },
      {
        jobName: "Paint Interior",
        jobId: "JOB000044515",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["PAINT"],
      totalActiveTime: "6h 30m",
      totalIdleTime: "0h 48m",
    },
  },
  {
    employeeId: "101044",
    fullName: "Shaundale Arthur",
    department: "TNT",
    team: "TNT",
    currentZone: "PAINT",
    currentJob: "Paint Exterior",
    lastUpdated: "2026-05-08 13:13",
    tagBatteryPct: 93,
    indirectMinutes: 6,
    avgTaskDurationMins: 45,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044521",
        status: "Completed",
        duration: "208m",
      },
      {
        jobName: "Paint Exterior",
        jobId: "JOB000044528",
        status: "Completed",
        duration: "212m",
      },
      {
        jobName: "Paint Exterior",
        jobId: "JOB000044535",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["PAINT"],
      totalActiveTime: "6h 32m",
      totalIdleTime: "0h 46m",
    },
  },
  {
    employeeId: "104209",
    fullName: "Tristan Brant",
    department: "TNT",
    team: "TNT",
    currentZone: "Station 6",
    currentJob: "Texture Coat",
    lastUpdated: "2026-05-08 13:29",
    tagBatteryPct: 95,
    indirectMinutes: 6,
    avgTaskDurationMins: 43,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044561",
        status: "Completed",
        duration: "210m",
      },
      {
        jobName: "Texture Coat",
        jobId: "JOB000044568",
        status: "Completed",
        duration: "205m",
      },
      {
        jobName: "Texture Coat",
        jobId: "JOB000044575",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 5", "Station 6"],
      totalActiveTime: "6h 28m",
      totalIdleTime: "0h 50m",
    },
  },
  {
    employeeId: "104741",
    fullName: "Ticura Chanthakham",
    department: "TNT",
    team: "TNT",
    currentZone: "Station 7",
    currentJob: "Tape and Mud",
    lastUpdated: "2026-05-08 13:37",
    tagBatteryPct: 91,
    indirectMinutes: 6,
    avgTaskDurationMins: 44,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044581",
        status: "Completed",
        duration: "212m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044588",
        status: "Completed",
        duration: "209m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044595",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 6", "Station 7"],
      totalActiveTime: "6h 33m",
      totalIdleTime: "0h 55m",
    },
  },
  {
    employeeId: "100981",
    fullName: "Uipa Ili",
    department: "TNT",
    team: "TNT",
    currentZone: "Station 9",
    currentJob: "Texture Coat",
    lastUpdated: "2026-05-08 13:45",
    tagBatteryPct: 98,
    indirectMinutes: 6,
    avgTaskDurationMins: 45,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044601",
        status: "Completed",
        duration: "216m",
      },
      {
        jobName: "Texture Coat",
        jobId: "JOB000044608",
        status: "Completed",
        duration: "207m",
      },
      {
        jobName: "Texture Coat",
        jobId: "JOB000044615",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 8", "Station 9"],
      totalActiveTime: "6h 37m",
      totalIdleTime: "0h 51m",
    },
  },
  {
    employeeId: "100985",
    fullName: "Ulano Jones",
    department: "TNT",
    team: "TNT",
    currentZone: "Station 10",
    currentJob: "Tape and Mud",
    lastUpdated: "2026-05-08 13:53",
    tagBatteryPct: 94,
    indirectMinutes: 6,
    avgTaskDurationMins: 44,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044621",
        status: "Completed",
        duration: "213m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044628",
        status: "Completed",
        duration: "206m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044635",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["Station 9", "Station 10"],
      totalActiveTime: "6h 31m",
      totalIdleTime: "0h 57m",
    },
  },
  {
    employeeId: "101034",
    fullName: "Joel Reyes Rios",
    department: "TNT",
    team: "TNT",
    currentZone: "Station 12",
    currentJob: "Texture Coat",
    lastUpdated: "2026-05-08 13:08",
    tagBatteryPct: 92,
    indirectMinutes: 6,
    avgTaskDurationMins: 43,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044641",
        status: "Completed",
        duration: "209m",
      },
      {
        jobName: "Texture Coat",
        jobId: "JOB000044648",
        status: "Completed",
        duration: "204m",
      },
      {
        jobName: "Texture Coat",
        jobId: "JOB000044655",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 11", "Station 12"],
      totalActiveTime: "6h 26m",
      totalIdleTime: "0h 52m",
    },
  },
  {
    employeeId: "103741",
    fullName: "Ubaldo Rodriguez",
    department: "TNT",
    team: "TNT",
    currentZone: "Station 13",
    currentJob: "Tape and Mud",
    lastUpdated: "2026-05-08 13:16",
    tagBatteryPct: 90,
    indirectMinutes: 6,
    avgTaskDurationMins: 44,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044661",
        status: "Completed",
        duration: "215m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044668",
        status: "Completed",
        duration: "210m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044675",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 12", "Station 13"],
      totalActiveTime: "6h 38m",
      totalIdleTime: "0h 50m",
    },
  },
  {
    employeeId: "103390",
    fullName: "Isaac Soliz",
    department: "TNT",
    team: "TNT",
    currentZone: "Station 15",
    currentJob: "Texture Coat",
    lastUpdated: "2026-05-08 13:24",
    tagBatteryPct: 96,
    indirectMinutes: 6,
    avgTaskDurationMins: 45,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044681",
        status: "Completed",
        duration: "211m",
      },
      {
        jobName: "Texture Coat",
        jobId: "JOB000044688",
        status: "Completed",
        duration: "208m",
      },
      {
        jobName: "Texture Coat",
        jobId: "JOB000044695",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 14", "Station 15"],
      totalActiveTime: "6h 29m",
      totalIdleTime: "0h 49m",
    },
  },
  {
    employeeId: "101057",
    fullName: "Michael Taylor",
    department: "TNT",
    team: "TNT",
    currentZone: "Station 17",
    currentJob: "Tape and Mud",
    lastUpdated: "2026-05-08 13:32",
    tagBatteryPct: 94,
    indirectMinutes: 6,
    avgTaskDurationMins: 44,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044701",
        status: "Completed",
        duration: "213m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044708",
        status: "Completed",
        duration: "207m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044715",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 16", "Station 17"],
      totalActiveTime: "6h 34m",
      totalIdleTime: "0h 54m",
    },
  },
  {
    employeeId: "103742",
    fullName: "Cristofer Valencia",
    department: "TNT",
    team: "TNT",
    currentZone: "Station 19",
    currentJob: "Texture Coat",
    lastUpdated: "2026-05-08 13:40",
    tagBatteryPct: 91,
    indirectMinutes: 6,
    avgTaskDurationMins: 43,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044721",
        status: "Completed",
        duration: "210m",
      },
      {
        jobName: "Texture Coat",
        jobId: "JOB000044728",
        status: "Completed",
        duration: "203m",
      },
      {
        jobName: "Texture Coat",
        jobId: "JOB000044735",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 18", "Station 19"],
      totalActiveTime: "6h 27m",
      totalIdleTime: "0h 51m",
    },
  },
  {
    employeeId: "101066",
    fullName: "Austin Weston",
    department: "TNT",
    team: "TNT",
    currentZone: "Station 20",
    currentJob: "Tape and Mud",
    lastUpdated: "2026-05-08 13:48",
    tagBatteryPct: 97,
    indirectMinutes: 6,
    avgTaskDurationMins: 44,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044741",
        status: "Completed",
        duration: "214m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044748",
        status: "Completed",
        duration: "209m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044755",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 19", "Station 20"],
      totalActiveTime: "6h 36m",
      totalIdleTime: "0h 52m",
    },
  },

  {
    employeeId: "104840",
    fullName: "Angel Farias",
    department: "Exteriors",
    team: "EXTERIORS",
    currentZone: "Station 4",
    currentJob: "Sheathing (Exterior)",
    lastUpdated: "2026-05-08 13:06",
    tagBatteryPct: 96,
    indirectMinutes: 6,
    avgTaskDurationMins: 47,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043301",
        status: "Completed",
        duration: "18m",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000043315",
        status: "Completed",
        duration: "108m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043328",
        status: "Completed",
        duration: "98m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043335",
        status: "Completed",
        duration: "101m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043342",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 4", "Station 5"],
      totalActiveTime: "6h 10m",
      totalIdleTime: "0h 18m",
    },
  },
  {
    employeeId: "103628",
    fullName: "Alexis Garcia",
    department: "Exteriors",
    team: "EXTERIORS",
    currentZone: "Station 8",
    currentJob: "Insulation",
    lastUpdated: "2026-05-08 13:30",
    tagBatteryPct: 91,
    indirectMinutes: 5,
    avgTaskDurationMins: 25,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043468",
        status: "Completed",
        duration: "91m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043475",
        status: "Completed",
        duration: "95m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043482",
        status: "Completed",
        duration: "100m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043489",
        status: "Completed",
        duration: "106m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043496",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 7", "Station 8", "Station 9"],
      totalActiveTime: "6h 20m",
      totalIdleTime: "0h 08m",
    },
  },
  {
    employeeId: "103597",
    fullName: "Daymeon Guy",
    department: "Exteriors",
    team: "EXTERIORS",
    currentZone: "Station 9",
    currentJob: "Sheathing (Exterior)",
    lastUpdated: "2026-05-08 13:38",
    tagBatteryPct: 95,
    indirectMinutes: 6,
    avgTaskDurationMins: 47,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043502",
        status: "Completed",
        duration: "17m",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000043516",
        status: "Completed",
        duration: "110m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043529",
        status: "Completed",
        duration: "99m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043536",
        status: "Completed",
        duration: "104m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043543",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 8", "Station 9", "Station 10"],
      totalActiveTime: "6h 14m",
      totalIdleTime: "0h 14m",
    },
  },
  {
    employeeId: "100996",
    fullName: "Rosalio Marquez",
    department: "Exteriors",
    team: "EXTERIORS",
    currentZone: "Station 10",
    currentJob: "Insulation",
    lastUpdated: "2026-05-08 13:46",
    tagBatteryPct: 93,
    indirectMinutes: 5,
    avgTaskDurationMins: 24,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043549",
        status: "Completed",
        duration: "92m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043556",
        status: "Completed",
        duration: "96m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043563",
        status: "Completed",
        duration: "101m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043570",
        status: "Completed",
        duration: "107m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043577",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 9", "Station 10", "Station 11"],
      totalActiveTime: "6h 24m",
      totalIdleTime: "0h 04m",
    },
  },
  {
    employeeId: "101007",
    fullName: "Michael Miller",
    department: "Exteriors",
    team: "EXTERIORS",
    currentZone: "Station 11",
    currentJob: "Sheathing (Exterior)",
    lastUpdated: "2026-05-08 13:54",
    tagBatteryPct: 90,
    indirectMinutes: 6,
    avgTaskDurationMins: 48,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043583",
        status: "Completed",
        duration: "20m",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000043597",
        status: "Completed",
        duration: "112m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043610",
        status: "Completed",
        duration: "97m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043617",
        status: "Completed",
        duration: "102m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043624",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 10", "Station 11", "Station 12"],
      totalActiveTime: "6h 12m",
      totalIdleTime: "0h 16m",
    },
  },
  {
    employeeId: "C100218",
    fullName: "Frank Reyes",
    department: "Exteriors",
    team: "EXTERIORS",
    currentZone: "Station 12",
    currentJob: "Insulation",
    lastUpdated: "2026-05-08 13:09",
    tagBatteryPct: 98,
    indirectMinutes: 5,
    avgTaskDurationMins: 25,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043630",
        status: "Completed",
        duration: "94m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043637",
        status: "Completed",
        duration: "91m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043644",
        status: "Completed",
        duration: "99m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043651",
        status: "Completed",
        duration: "108m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043658",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 11", "Station 12", "Station 13"],
      totalActiveTime: "6h 26m",
      totalIdleTime: "0h 02m",
    },
  },
  {
    employeeId: "104841",
    fullName: "Gabriel Sandoval",
    department: "Exteriors",
    team: "EXTERIORS",
    currentZone: "Station 13",
    currentJob: "Sheathing (Exterior)",
    lastUpdated: "2026-05-08 13:17",
    tagBatteryPct: 96,
    indirectMinutes: 6,
    avgTaskDurationMins: 47,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043664",
        status: "Completed",
        duration: "18m",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000043678",
        status: "Completed",
        duration: "111m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043691",
        status: "Completed",
        duration: "95m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043698",
        status: "Completed",
        duration: "100m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043705",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 12", "Station 13", "Station 14"],
      totalActiveTime: "6h 08m",
      totalIdleTime: "0h 20m",
    },
  },
  {
    employeeId: "101045",
    fullName: "Clinton Shullaw",
    department: "Exteriors",
    team: "EXTERIORS",
    currentZone: "Station 14",
    currentJob: "Insulation",
    lastUpdated: "2026-05-08 13:25",
    tagBatteryPct: 92,
    indirectMinutes: 5,
    avgTaskDurationMins: 24,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043711",
        status: "Completed",
        duration: "90m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043718",
        status: "Completed",
        duration: "94m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043725",
        status: "Completed",
        duration: "102m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043732",
        status: "Completed",
        duration: "105m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043739",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 13", "Station 14", "Station 15"],
      totalActiveTime: "6h 20m",
      totalIdleTime: "0h 08m",
    },
  },
  {
    employeeId: "104923",
    fullName: "Eduardo Siordia",
    department: "Exteriors",
    team: "EXTERIORS",
    currentZone: "Station 15",
    currentJob: "Sheathing (Exterior)",
    lastUpdated: "2026-05-08 13:33",
    tagBatteryPct: 94,
    indirectMinutes: 6,
    avgTaskDurationMins: 48,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043745",
        status: "Completed",
        duration: "19m",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000043759",
        status: "Completed",
        duration: "113m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043772",
        status: "Completed",
        duration: "97m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043779",
        status: "Completed",
        duration: "103m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043786",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["Station 14", "Station 15", "Station 16"],
      totalActiveTime: "6h 16m",
      totalIdleTime: "0h 12m",
    },
  },
  {
    employeeId: "101058",
    fullName: "Dominick Teller",
    department: "Exteriors",
    team: "EXTERIORS",
    currentZone: "Station 16",
    currentJob: "Insulation",
    lastUpdated: "2026-05-08 13:41",
    tagBatteryPct: 91,
    indirectMinutes: 5,
    avgTaskDurationMins: 25,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043792",
        status: "Completed",
        duration: "93m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043799",
        status: "Completed",
        duration: "97m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043806",
        status: "Completed",
        duration: "103m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043813",
        status: "Completed",
        duration: "106m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043820",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 15", "Station 16", "Station 17"],
      totalActiveTime: "6h 22m",
      totalIdleTime: "0h 06m",
    },
  },
  {
    employeeId: "104679",
    fullName: "Ramon Uriate",
    department: "Exteriors",
    team: "EXTERIORS",
    currentZone: "Station 17",
    currentJob: "Sheathing (Exterior)",
    lastUpdated: "2026-05-08 13:49",
    tagBatteryPct: 97,
    indirectMinutes: 6,
    avgTaskDurationMins: 47,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000043826",
        status: "Completed",
        duration: "17m",
      },
      {
        jobName: "Fire Wall Assembly",
        jobId: "JOB000043840",
        status: "Completed",
        duration: "109m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043853",
        status: "Completed",
        duration: "96m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043860",
        status: "Completed",
        duration: "102m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000043867",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 16", "Station 17", "Station 18"],
      totalActiveTime: "6h 14m",
      totalIdleTime: "0h 14m",
    },
  },
  {
    employeeId: "103627",
    fullName: "Gabriel Valles",
    department: "Exteriors",
    team: "EXTERIORS",
    currentZone: "Station 18",
    currentJob: "Insulation",
    lastUpdated: "2026-05-08 13:57",
    tagBatteryPct: 93,
    indirectMinutes: 5,
    avgTaskDurationMins: 24,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043873",
        status: "Completed",
        duration: "92m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043880",
        status: "Completed",
        duration: "95m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043887",
        status: "Completed",
        duration: "100m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043894",
        status: "Completed",
        duration: "107m",
      },
      {
        jobName: "Insulation",
        jobId: "JOB000043901",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 4,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 17", "Station 18", "Station 19"],
      totalActiveTime: "6h 24m",
      totalIdleTime: "0h 04m",
    },
  },

  {
    employeeId: "100916",
    fullName: "Erick Armenta",
    department: "FFE - Flooring",
    team: "FFE/FLOOR",
    currentZone: "Station 14",
    currentJob: "Final Clean Up For Shipment",
    lastUpdated: "2026-05-08 13:06",
    tagBatteryPct: 97,
    indirectMinutes: 8,
    avgTaskDurationMins: 26,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Flooring Install",
        jobId: "JOB000044201",
        status: "Completed",
        duration: "45m",
      },
      {
        jobName: "Flooring Install",
        jobId: "JOB000044208",
        status: "Completed",
        duration: "52m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044215",
        status: "Completed",
        duration: "138m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044222",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 13", "Station 14"],
      totalActiveTime: "6h 38m",
      totalIdleTime: "0h 50m",
    },
  },
  {
    employeeId: "100953",
    fullName: "Shane Fry",
    department: "FFE - Flooring",
    team: "FFE/FLOOR",
    currentZone: "Station 15",
    currentJob: "Vinyl Install",
    lastUpdated: "2026-05-08 13:14",
    tagBatteryPct: 94,
    indirectMinutes: 8,
    avgTaskDurationMins: 25,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Vinyl Install",
        jobId: "JOB000044228",
        status: "Completed",
        duration: "48m",
      },
      {
        jobName: "Vinyl Install",
        jobId: "JOB000044235",
        status: "Completed",
        duration: "51m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044242",
        status: "Completed",
        duration: "142m",
      },
      {
        jobName: "Vinyl Install",
        jobId: "JOB000044249",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 14", "Station 15"],
      totalActiveTime: "6h 42m",
      totalIdleTime: "0h 46m",
    },
  },
  {
    employeeId: "100986",
    fullName: "Michael Lancaster",
    department: "FFE - Flooring",
    team: "FFE/FLOOR",
    currentZone: "Station 16",
    currentJob: "Final Plumbing",
    lastUpdated: "2026-05-08 13:22",
    tagBatteryPct: 91,
    indirectMinutes: 8,
    avgTaskDurationMins: 26,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044255",
        status: "Completed",
        duration: "51m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044262",
        status: "Completed",
        duration: "144m",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000044269",
        status: "Completed",
        duration: "118m",
      },
      {
        jobName: "Final Plumbing",
        jobId: "JOB000044276",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 15", "Station 16"],
      totalActiveTime: "6h 44m",
      totalIdleTime: "0h 44m",
    },
  },
  {
    employeeId: "100988",
    fullName: "Jorge Leon Arvizu",
    department: "FFE - Flooring",
    team: "FFE/FLOOR",
    currentZone: "Station 17",
    currentJob: "Carpet Install",
    lastUpdated: "2026-05-08 13:30",
    tagBatteryPct: 98,
    indirectMinutes: 8,
    avgTaskDurationMins: 25,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Carpet Install",
        jobId: "JOB000044282",
        status: "Completed",
        duration: "46m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044289",
        status: "Completed",
        duration: "148m",
      },
      {
        jobName: "Carpet Install",
        jobId: "JOB000044296",
        status: "Completed",
        duration: "122m",
      },
      {
        jobName: "Carpet Install",
        jobId: "JOB000044303",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 16", "Station 17"],
      totalActiveTime: "6h 46m",
      totalIdleTime: "0h 42m",
    },
  },
  {
    employeeId: "101021",
    fullName: "Jesus Orona",
    department: "FFE - Flooring",
    team: "FFE/FLOOR",
    currentZone: "Station 18",
    currentJob: "Final Clean Up For Shipment",
    lastUpdated: "2026-05-08 13:38",
    tagBatteryPct: 95,
    indirectMinutes: 8,
    avgTaskDurationMins: 26,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Flooring Install",
        jobId: "JOB000044309",
        status: "Completed",
        duration: "47m",
      },
      {
        jobName: "Flooring Install",
        jobId: "JOB000044316",
        status: "Completed",
        duration: "53m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044323",
        status: "Completed",
        duration: "141m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044330",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 17", "Station 18"],
      totalActiveTime: "6h 40m",
      totalIdleTime: "0h 48m",
    },
  },
  {
    employeeId: "105047",
    fullName: "Lola Rivera",
    department: "FFE - Flooring",
    team: "FFE/FLOOR",
    currentZone: "Station 20",
    currentJob: "Vinyl Install",
    lastUpdated: "2026-05-08 13:54",
    tagBatteryPct: 90,
    indirectMinutes: 8,
    avgTaskDurationMins: 26,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Vinyl Install",
        jobId: "JOB000044342",
        status: "Completed",
        duration: "49m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044349",
        status: "Completed",
        duration: "146m",
      },
      {
        jobName: "Vinyl Install",
        jobId: "JOB000044356",
        status: "Completed",
        duration: "120m",
      },
      {
        jobName: "Vinyl Install",
        jobId: "JOB000044363",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 19", "Station 20"],
      totalActiveTime: "6h 48m",
      totalIdleTime: "0h 40m",
    },
  },
  {
    employeeId: "101053",
    fullName: "Frederick Straun",
    department: "FFE - Flooring",
    team: "FFE/FLOOR",
    currentZone: "Station 13",
    currentJob: "Carpet Install",
    lastUpdated: "2026-05-08 13:42",
    tagBatteryPct: 96,
    indirectMinutes: 8,
    avgTaskDurationMins: 25,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Carpet Install",
        jobId: "JOB000044369",
        status: "Completed",
        duration: "46m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044376",
        status: "Completed",
        duration: "147m",
      },
      {
        jobName: "Carpet Install",
        jobId: "JOB000044383",
        status: "Completed",
        duration: "119m",
      },
      {
        jobName: "Carpet Install",
        jobId: "JOB000044390",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["Station 12", "Station 13"],
      totalActiveTime: "6h 36m",
      totalIdleTime: "0h 52m",
    },
  },
  {
    employeeId: "101070",
    fullName: "Alexis Wolpert",
    department: "FFE - Flooring",
    team: "FFE/FLOOR",
    currentZone: "Station 12",
    currentJob: "Final Clean Up For Shipment",
    lastUpdated: "2026-05-08 13:58",
    tagBatteryPct: 92,
    indirectMinutes: 8,
    avgTaskDurationMins: 26,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Flooring Install",
        jobId: "JOB000044396",
        status: "Completed",
        duration: "50m",
      },
      {
        jobName: "Flooring Install",
        jobId: "JOB000044403",
        status: "Completed",
        duration: "54m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044410",
        status: "Completed",
        duration: "143m",
      },
      {
        jobName: "Final Clean Up For Shipment",
        jobId: "JOB000044417",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 11", "Station 12"],
      totalActiveTime: "6h 34m",
      totalIdleTime: "0h 54m",
    },
  },

  {
    employeeId: "100944",
    fullName: "David Derichsweiler",
    department: "Yard",
    team: "YARD",
    currentZone: "Station 4",
    currentJob: "Forklift Operation",
    lastUpdated: "2026-05-08 13:21",
    tagBatteryPct: 94,
    indirectMinutes: 15,
    avgTaskDurationMins: 188,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000027604",
        status: "Completed",
        duration: "176m",
      },
      {
        jobName: "Forklift Operation",
        jobId: "JOB000027611",
        status: "Completed",
        duration: "199m",
      },
      {
        jobName: "Forklift Operation",
        jobId: "JOB000027618",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 4", "Station 5", "Station 6"],
      totalActiveTime: "7h 08m",
      totalIdleTime: "0h 16m",
    },
  },
  {
    employeeId: "100999",
    fullName: "Ramon Martinez",
    department: "Yard",
    team: "YARD",
    currentZone: "Station 12",
    currentJob: "Yard Work",
    lastUpdated: "2026-05-08 13:34",
    tagBatteryPct: 91,
    indirectMinutes: 15,
    avgTaskDurationMins: 191,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000027624",
        status: "Completed",
        duration: "181m",
      },
      {
        jobName: "Yard Work",
        jobId: "JOB000027631",
        status: "Completed",
        duration: "207m",
      },
      {
        jobName: "Yard Work",
        jobId: "JOB000027638",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 11", "Station 12", "Station 13"],
      totalActiveTime: "7h 20m",
      totalIdleTime: "0h 04m",
    },
  },
  {
    employeeId: "101041",
    fullName: "Maxwell Ruiz",
    department: "Yard",
    team: "YARD",
    currentZone: "Station 20",
    currentJob: "Forklift Operation",
    lastUpdated: "2026-05-08 13:47",
    tagBatteryPct: 90,
    indirectMinutes: 15,
    avgTaskDurationMins: 195,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Handling",
        jobId: "JOB000027644",
        status: "Completed",
        duration: "179m",
      },
      {
        jobName: "Forklift Operation",
        jobId: "JOB000027651",
        status: "Completed",
        duration: "212m",
      },
      {
        jobName: "Forklift Operation",
        jobId: "JOB000027658",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "05:00",
      shiftEnd: "N/A",
      jobsCompleted: 2,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 19", "Station 20"],
      totalActiveTime: "7h 18m",
      totalIdleTime: "0h 06m",
    },
  },

  {
    employeeId: "100933",
    fullName: "Jose Casillas",
    department: "Roofing",
    team: "ROOF",
    currentZone: "Station 6",
    currentJob: "Roof Framing",
    lastUpdated: "2026-05-08 13:07",
    tagBatteryPct: 97,
    indirectMinutes: 10,
    avgTaskDurationMins: 238,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Roof Framing",
        jobId: "JOB000045101",
        status: "Completed",
        duration: "244m",
      },
      {
        jobName: "Roof Framing",
        jobId: "JOB000045108",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 5", "Station 6"],
      totalActiveTime: "5h 32m",
      totalIdleTime: "0h 16m",
    },
  },
  {
    employeeId: "100962",
    fullName: "Jeremy Goritski",
    department: "Roofing",
    team: "ROOF",
    currentZone: "Station 9",
    currentJob: "Sheathing (Exterior)",
    lastUpdated: "2026-05-08 13:19",
    tagBatteryPct: 94,
    indirectMinutes: 10,
    avgTaskDurationMins: 242,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000045114",
        status: "Completed",
        duration: "251m",
      },
      {
        jobName: "Sheathing (Exterior)",
        jobId: "JOB000045121",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 8", "Station 9"],
      totalActiveTime: "5h 40m",
      totalIdleTime: "0h 08m",
    },
  },
  {
    employeeId: "104541",
    fullName: "Dominic Guevara",
    department: "Roofing",
    team: "ROOF",
    currentZone: "Station 12",
    currentJob: "Roof Decking",
    lastUpdated: "2026-05-08 13:31",
    tagBatteryPct: 98,
    indirectMinutes: 10,
    avgTaskDurationMins: 240,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Roof Decking",
        jobId: "JOB000045127",
        status: "Completed",
        duration: "255m",
      },
      {
        jobName: "Roof Decking",
        jobId: "JOB000045134",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 11", "Station 12"],
      totalActiveTime: "5h 44m",
      totalIdleTime: "0h 04m",
    },
  },

  {
    employeeId: "104677",
    fullName: "Cortez Valenzuela",
    department: "Roofing",
    team: "ROOF",
    currentZone: "Station 18",
    currentJob: "Felt / Underlayment",
    lastUpdated: "2026-05-08 13:55",
    tagBatteryPct: 91,
    indirectMinutes: 10,
    avgTaskDurationMins: 243,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Felt / Underlayment",
        jobId: "JOB000045146",
        status: "Completed",
        duration: "248m",
      },
      {
        jobName: "Felt / Underlayment",
        jobId: "JOB000045153",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 17", "Station 18"],
      totalActiveTime: "5h 36m",
      totalIdleTime: "0h 14m",
    },
  },

  {
    employeeId: "100940",
    fullName: "Ryan Decou",
    department: "Cabinet",
    team: "CAB",
    currentZone: "CAB",
    currentJob: "Cabinet Assembly",
    lastUpdated: "2026-05-08 13:13",
    tagBatteryPct: 94,
    indirectMinutes: 10,
    avgTaskDurationMins: 33,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047002",
        status: "Completed",
        duration: "34m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047009",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047016",
        status: "Completed",
        duration: "35m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047023",
        status: "Completed",
        duration: "32m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047030",
        status: "Completed",
        duration: "29m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047037",
        status: "Completed",
        duration: "36m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047044",
        status: "Completed",
        duration: "33m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047051",
        status: "Completed",
        duration: "30m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047058",
        status: "Completed",
        duration: "34m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047065",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047072",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 10,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["CAB"],
      totalActiveTime: "5h 48m",
      totalIdleTime: "0h 18m",
    },
  },
  {
    employeeId: "104742",
    fullName: "Alexander Guerrero",
    department: "Cabinet",
    team: "CAB",
    currentZone: "CAB",
    currentJob: "Cabinet Build Material Fabrication",
    lastUpdated: "2026-05-08 13:21",
    tagBatteryPct: 91,
    indirectMinutes: 10,
    avgTaskDurationMins: 32,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047078",
        status: "Completed",
        duration: "33m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047085",
        status: "Completed",
        duration: "30m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047092",
        status: "Completed",
        duration: "36m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047099",
        status: "Completed",
        duration: "29m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047106",
        status: "Completed",
        duration: "34m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047113",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047120",
        status: "Completed",
        duration: "35m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047127",
        status: "Completed",
        duration: "28m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047134",
        status: "Completed",
        duration: "32m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047141",
        status: "Completed",
        duration: "30m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047148",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 10,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["CAB"],
      totalActiveTime: "5h 41m",
      totalIdleTime: "0h 25m",
    },
  },
  {
    employeeId: "100990",
    fullName: "Tania Leyva",
    department: "Cabinet",
    team: "CAB",
    currentZone: "CAB",
    currentJob: "Cabinet Door Hang",
    lastUpdated: "2026-05-08 13:29",
    tagBatteryPct: 98,
    indirectMinutes: 10,
    avgTaskDurationMins: 34,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Cabinet Door Hang",
        jobId: "JOB000047154",
        status: "Completed",
        duration: "35m",
      },
      {
        jobName: "Cabinet Door Hang",
        jobId: "JOB000047161",
        status: "Completed",
        duration: "32m",
      },
      {
        jobName: "Cabinet Door Hang",
        jobId: "JOB000047168",
        status: "Completed",
        duration: "37m",
      },
      {
        jobName: "Cabinet Door Hang",
        jobId: "JOB000047175",
        status: "Completed",
        duration: "30m",
      },
      {
        jobName: "Cabinet Door Hang",
        jobId: "JOB000047182",
        status: "Completed",
        duration: "34m",
      },
      {
        jobName: "Cabinet Door Hang",
        jobId: "JOB000047189",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Door Hang",
        jobId: "JOB000047196",
        status: "Completed",
        duration: "36m",
      },
      {
        jobName: "Cabinet Door Hang",
        jobId: "JOB000047203",
        status: "Completed",
        duration: "29m",
      },
      {
        jobName: "Cabinet Door Hang",
        jobId: "JOB000047210",
        status: "Completed",
        duration: "33m",
      },
      {
        jobName: "Cabinet Door Hang",
        jobId: "JOB000047217",
        status: "Completed",
        duration: "32m",
      },
      {
        jobName: "Cabinet Door Hang",
        jobId: "JOB000047224",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 10,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["CAB"],
      totalActiveTime: "5h 46m",
      totalIdleTime: "0h 20m",
    },
  },
  {
    employeeId: "103625",
    fullName: "Jose Lopez",
    department: "Cabinet",
    team: "CAB",
    currentZone: "CAB",
    currentJob: "Cabinet Assembly",
    lastUpdated: "2026-05-08 13:37",
    tagBatteryPct: 95,
    indirectMinutes: 10,
    avgTaskDurationMins: 31,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047230",
        status: "Completed",
        duration: "32m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047237",
        status: "Completed",
        duration: "29m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047244",
        status: "Completed",
        duration: "34m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047251",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047258",
        status: "Completed",
        duration: "28m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047265",
        status: "Completed",
        duration: "35m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047272",
        status: "Completed",
        duration: "30m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047279",
        status: "Completed",
        duration: "33m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047286",
        status: "Completed",
        duration: "29m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047293",
        status: "Completed",
        duration: "32m",
      },
      {
        jobName: "Cabinet Assembly",
        jobId: "JOB000047300",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 10,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["CAB"],
      totalActiveTime: "5h 45m",
      totalIdleTime: "0h 21m",
    },
  },
  {
    employeeId: "104676",
    fullName: "Jackson Nielson",
    department: "Cabinet",
    team: "CAB",
    currentZone: "CAB",
    currentJob: "Cabinet Hardware Install",
    lastUpdated: "2026-05-08 13:45",
    tagBatteryPct: 92,
    indirectMinutes: 10,
    avgTaskDurationMins: 33,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Cabinet Hardware Install",
        jobId: "JOB000047306",
        status: "Completed",
        duration: "34m",
      },
      {
        jobName: "Cabinet Hardware Install",
        jobId: "JOB000047313",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Hardware Install",
        jobId: "JOB000047320",
        status: "Completed",
        duration: "36m",
      },
      {
        jobName: "Cabinet Hardware Install",
        jobId: "JOB000047327",
        status: "Completed",
        duration: "29m",
      },
      {
        jobName: "Cabinet Hardware Install",
        jobId: "JOB000047334",
        status: "Completed",
        duration: "33m",
      },
      {
        jobName: "Cabinet Hardware Install",
        jobId: "JOB000047341",
        status: "Completed",
        duration: "30m",
      },
      {
        jobName: "Cabinet Hardware Install",
        jobId: "JOB000047348",
        status: "Completed",
        duration: "35m",
      },
      {
        jobName: "Cabinet Hardware Install",
        jobId: "JOB000047355",
        status: "Completed",
        duration: "28m",
      },
      {
        jobName: "Cabinet Hardware Install",
        jobId: "JOB000047362",
        status: "Completed",
        duration: "32m",
      },
      {
        jobName: "Cabinet Hardware Install",
        jobId: "JOB000047369",
        status: "Completed",
        duration: "34m",
      },
      {
        jobName: "Cabinet Hardware Install",
        jobId: "JOB000047376",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 10,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["CAB"],
      totalActiveTime: "5h 50m",
      totalIdleTime: "0h 16m",
    },
  },
  {
    employeeId: "101063",
    fullName: "Andrew Volpetti",
    department: "Cabinet",
    team: "CAB",
    currentZone: "CAB",
    currentJob: "Cabinet Build Material Fabrication",
    lastUpdated: "2026-05-08 13:53",
    tagBatteryPct: 90,
    indirectMinutes: 10,
    avgTaskDurationMins: 32,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047382",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047389",
        status: "Completed",
        duration: "34m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047396",
        status: "Completed",
        duration: "29m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047403",
        status: "Completed",
        duration: "36m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047410",
        status: "Completed",
        duration: "30m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047417",
        status: "Completed",
        duration: "33m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047424",
        status: "Completed",
        duration: "35m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047431",
        status: "Completed",
        duration: "28m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047438",
        status: "Completed",
        duration: "32m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047445",
        status: "Completed",
        duration: "31m",
      },
      {
        jobName: "Cabinet Build Material Fabrication",
        jobId: "JOB000047452",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 10,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["CAB"],
      totalActiveTime: "5h 44m",
      totalIdleTime: "0h 22m",
    },
  },

  {
    employeeId: "100940",
    fullName: "Clayton Cridlebaugh",
    department: "Rough Electrical",
    team: "ROUGH ELEC",
    currentZone: "Station 5",
    currentJob: "Electrical Rough-In",
    lastUpdated: "2026-05-08 13:07",
    tagBatteryPct: 97,
    indirectMinutes: 10,
    avgTaskDurationMins: 252,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000046401",
        status: "Completed",
        duration: "258m",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000046415",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 4", "Station 5"],
      totalActiveTime: "5h 32m",
      totalIdleTime: "0h 16m",
    },
  },
  {
    employeeId: "100963",
    fullName: "Joseph Goritski",
    department: "Rough Electrical",
    team: "ROUGH ELEC",
    currentZone: "Station 8",
    currentJob: "Low Voltage Rough-In",
    lastUpdated: "2026-05-08 13:19",
    tagBatteryPct: 94,
    indirectMinutes: 10,
    avgTaskDurationMins: 257,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000046429",
        status: "Completed",
        duration: "263m",
      },
      {
        jobName: "Low Voltage Rough-In",
        jobId: "JOB000046443",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 7", "Station 8", "Station 9"],
      totalActiveTime: "5h 40m",
      totalIdleTime: "0h 08m",
    },
  },
  {
    employeeId: "CW100256",
    fullName: "Christopher Grant",
    department: "Rough Electrical",
    team: "ROUGH ELEC",
    currentZone: "Station 11",
    currentJob: "Panel Rough-In",
    lastUpdated: "2026-05-08 13:31",
    tagBatteryPct: 98,
    indirectMinutes: 10,
    avgTaskDurationMins: 255,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000046457",
        status: "Completed",
        duration: "261m",
      },
      {
        jobName: "Panel Rough-In",
        jobId: "JOB000046471",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 1,
      stationsVisited: ["Station 10", "Station 11", "Station 12"],
      totalActiveTime: "5h 36m",
      totalIdleTime: "0h 12m",
    },
  },
  {
    employeeId: "103378",
    fullName: "Marcus Walker",
    department: "Rough Electrical",
    team: "ROUGH ELEC",
    currentZone: "Station 17",
    currentJob: "Low Voltage Rough-In",
    lastUpdated: "2026-05-08 13:55",
    tagBatteryPct: 91,
    indirectMinutes: 10,
    avgTaskDurationMins: 258,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Electrical Rough-In",
        jobId: "JOB000046499",
        status: "Completed",
        duration: "265m",
      },
      {
        jobName: "Low Voltage Rough-In",
        jobId: "JOB000046513",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 1,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 16", "Station 17", "Station 18"],
      totalActiveTime: "5h 44m",
      totalIdleTime: "0h 04m",
    },
  },

  {
    employeeId: "100924",
    fullName: "Greg Brent",
    department: "Trim Electrical",
    team: "TRIM ELEC",
    currentZone: "Station 5",
    currentJob: "Final Electrical",
    lastUpdated: "2026-05-08 13:07",
    tagBatteryPct: 97,
    indirectMinutes: 4,
    avgTaskDurationMins: 38,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044301",
        status: "Completed",
        duration: "124m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044315",
        status: "Completed",
        duration: "54m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044322",
        status: "Completed",
        duration: "82m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044329",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 4", "Station 5"],
      totalActiveTime: "6h 14m",
      totalIdleTime: "1h 14m",
    },
  },
  {
    employeeId: "100955",
    fullName: "Christian Garay",
    department: "Trim Electrical",
    team: "TRIM ELEC",
    currentZone: "Station 7",
    currentJob: "Low Voltage Trim",
    lastUpdated: "2026-05-08 13:15",
    tagBatteryPct: 94,
    indirectMinutes: 4,
    avgTaskDurationMins: 39,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044335",
        status: "Completed",
        duration: "131m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044342",
        status: "Completed",
        duration: "58m",
      },
      {
        jobName: "Low Voltage Trim",
        jobId: "JOB000044349",
        status: "Completed",
        duration: "79m",
      },
      {
        jobName: "Low Voltage Trim",
        jobId: "JOB000044356",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 6", "Station 7"],
      totalActiveTime: "6h 20m",
      totalIdleTime: "1h 08m",
    },
  },
  {
    employeeId: "103905",
    fullName: "Luis Gonzalez",
    department: "Trim Electrical",
    team: "TRIM ELEC",
    currentZone: "Station 10",
    currentJob: "Final Electrical",
    lastUpdated: "2026-05-08 13:23",
    tagBatteryPct: 91,
    indirectMinutes: 4,
    avgTaskDurationMins: 38,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044362",
        status: "Completed",
        duration: "127m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044369",
        status: "Completed",
        duration: "55m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044376",
        status: "Completed",
        duration: "84m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044383",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 9", "Station 10"],
      totalActiveTime: "6h 16m",
      totalIdleTime: "1h 12m",
    },
  },

  {
    employeeId: "C100219",
    fullName: "Hanna Jackson",
    department: "Trim Electrical",
    team: "TRIM ELEC",
    currentZone: "Station 14",
    currentJob: "Panel Trim-Out",
    lastUpdated: "2026-05-08 13:39",
    tagBatteryPct: 95,
    indirectMinutes: 4,
    avgTaskDurationMins: 39,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044395",
        status: "Completed",
        duration: "130m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044402",
        status: "Completed",
        duration: "56m",
      },
      {
        jobName: "Panel Trim-Out",
        jobId: "JOB000044409",
        status: "Completed",
        duration: "81m",
      },
      {
        jobName: "Panel Trim-Out",
        jobId: "JOB000044416",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 13", "Station 14"],
      totalActiveTime: "6h 22m",
      totalIdleTime: "1h 06m",
    },
  },
  {
    employeeId: "100997",
    fullName: "Gene Marsh",
    department: "Trim Electrical",
    team: "TRIM ELEC",
    currentZone: "Station 17",
    currentJob: "Final Electrical",
    lastUpdated: "2026-05-08 13:47",
    tagBatteryPct: 92,
    indirectMinutes: 4,
    avgTaskDurationMins: 38,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044422",
        status: "Completed",
        duration: "126m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044429",
        status: "Completed",
        duration: "53m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044436",
        status: "Completed",
        duration: "83m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044443",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 16", "Station 17"],
      totalActiveTime: "6h 16m",
      totalIdleTime: "1h 12m",
    },
  },
  {
    employeeId: "104683",
    fullName: "Destiney Perez",
    department: "Trim Electrical",
    team: "TRIM ELEC",
    currentZone: "Station 19",
    currentJob: "Low Voltage Trim",
    lastUpdated: "2026-05-08 13:55",
    tagBatteryPct: 90,
    indirectMinutes: 4,
    avgTaskDurationMins: 39,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tape and Mud",
        jobId: "JOB000044449",
        status: "Completed",
        duration: "129m",
      },
      {
        jobName: "Final Electrical",
        jobId: "JOB000044456",
        status: "Completed",
        duration: "57m",
      },
      {
        jobName: "Low Voltage Trim",
        jobId: "JOB000044463",
        status: "Completed",
        duration: "80m",
      },
      {
        jobName: "Low Voltage Trim",
        jobId: "JOB000044470",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 3,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["Station 18", "Station 19"],
      totalActiveTime: "6h 20m",
      totalIdleTime: "1h 08m",
    },
  },
  {
    employeeId: "100918",
    fullName: "America Arriaga",
    department: "Inventory/Receiving",
    team: "INV/REC",
    currentZone: "GENERAL WAREHOUSE",
    currentJob: "Receiving",
    lastUpdated: "2026-05-08 13:06",
    tagBatteryPct: 97,
    indirectMinutes: 447,
    avgTaskDurationMins: 440,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Receiving",
        jobId: "JOB000044958",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 0,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["GENERAL WAREHOUSE"],
      totalActiveTime: "5h 48m",
      totalIdleTime: "0h 0m",
    },
  },
  {
    employeeId: "100938",
    fullName: "Kevin Cottle",
    department: "Inventory/Receiving",
    team: "INV/REC",
    currentZone: "TOOL ROOM",
    currentJob: "Tool Room Management",
    lastUpdated: "2026-05-08 13:22",
    tagBatteryPct: 96,
    indirectMinutes: 447,
    avgTaskDurationMins: 447,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Tool Room Management",
        jobId: "JOB000044960",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 0,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["TOOL ROOM"],
      totalActiveTime: "5h 50m",
      totalIdleTime: "0h 0m",
    },
  },
  {
    employeeId: "104682",
    fullName: "Denali Garay",
    department: "Inventory/Receiving",
    team: "INV/REC",
    currentZone: "INVENTORY",
    currentJob: "Inventory Count",
    lastUpdated: "2026-05-08 13:30",
    tagBatteryPct: 93,
    indirectMinutes: 447,
    avgTaskDurationMins: 447,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Inventory Count",
        jobId: "JOB000044961",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 0,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["INVENTORY"],
      totalActiveTime: "5h 54m",
      totalIdleTime: "0h 0m",
    },
  },
  {
    employeeId: "105377",
    fullName: "Savannah Gass",
    department: "Inventory/Receiving",
    team: "INV/REC",
    currentZone: "GENERAL WAREHOUSE",
    currentJob: "Material Staging",
    lastUpdated: "2026-05-08 13:38",
    tagBatteryPct: 91,
    indirectMinutes: 447,
    avgTaskDurationMins: 438,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Staging",
        jobId: "JOB000044962",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 0,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["GENERAL WAREHOUSE"],
      totalActiveTime: "5h 46m",
      totalIdleTime: "0h 0m",
    },
  },
  {
    employeeId: "100998",
    fullName: "Liliana Martinez",
    department: "Inventory/Receiving",
    team: "INV/REC",
    currentZone: "GENERAL WAREHOUSE",
    currentJob: "Warehouse Work",
    lastUpdated: "2026-05-08 13:46",
    tagBatteryPct: 98,
    indirectMinutes: 447,
    avgTaskDurationMins: 443,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Warehouse Work",
        jobId: "JOB000044963",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 0,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["GENERAL WAREHOUSE"],
      totalActiveTime: "5h 50m",
      totalIdleTime: "0h 0m",
    },
  },
  {
    employeeId: "101013",
    fullName: "Scott Morrison",
    department: "Inventory/Receiving",
    team: "INV/REC",
    currentZone: "GENERAL WAREHOUSE",
    currentJob: "Receiving",
    lastUpdated: "2026-05-08 13:54",
    tagBatteryPct: 95,
    indirectMinutes: 447,
    avgTaskDurationMins: 441,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Receiving",
        jobId: "JOB000044964",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 0,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["GENERAL WAREHOUSE"],
      totalActiveTime: "5h 48m",
      totalIdleTime: "0h 0m",
    },
  },
  {
    employeeId: "101050",
    fullName: "Bunna Som",
    department: "Inventory/Receiving",
    team: "INV/REC",
    currentZone: "GENERAL WAREHOUSE",
    currentJob: "Material Staging",
    lastUpdated: "2026-05-08 13:09",
    tagBatteryPct: 92,
    indirectMinutes: 447,
    avgTaskDurationMins: 439,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Material Staging",
        jobId: "JOB000044965",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 0,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["GENERAL WAREHOUSE"],
      totalActiveTime: "5h 44m",
      totalIdleTime: "0h 0m",
    },
  },
  {
    employeeId: "101068",
    fullName: "Richard Williams",
    department: "Inventory/Receiving",
    team: "INV/REC",
    currentZone: "GENERAL WAREHOUSE",
    currentJob: "Warehouse Work",
    lastUpdated: "2026-05-08 13:17",
    tagBatteryPct: 90,
    indirectMinutes: 447,
    avgTaskDurationMins: 444,
    activityHistory: [
      {
        jobName: "Clock In",
        jobId: "JOB000027588",
        status: "Completed",
        duration: "1m",
      },
      {
        jobName: "Meeting",
        jobId: "JOB000027577",
        status: "Completed",
        duration: "10m",
      },
      {
        jobName: "Warehouse Work",
        jobId: "JOB000044966",
        status: "In Progress",
        duration: "—",
      },
    ],
    shiftSummary: {
      shiftStart: "06:00",
      shiftEnd: "N/A",
      jobsCompleted: 0,
      jobsInProgress: 1,
      nonconformancesRaised: 0,
      stationsVisited: ["GENERAL WAREHOUSE"],
      totalActiveTime: "5h 52m",
      totalIdleTime: "0h 0m",
    },
  },
];

export default MOCK_PERSONNEL;
